import React from "react";

import "./styles.scss";

export default function Nurse() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="freepik_stories-hospital-wheelchair"
            className="animated"
            version="1.1"
            viewBox="0 0 500 500"
        >
            <g
                id="freepik--background-complete--inject-2"
                style={{
                    WebkitTransformOrigin: 250,
                    MsTransformOrigin: 250,
                    transformOrigin: 250,
                }}
                className="animable"
            >
                <path
                    style={{
                        WebkitTransformOrigin: 250,
                        MsTransformOrigin: 250,
                        transformOrigin: 250,
                    }}
                    id="ela06eyy73fwh"
                    fill="#EBEBEB"
                    d="M48.57 189.92H451.43V230.35999999999999H48.57z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 329.515,
                        MsTransformOrigin: 329.515,
                        transformOrigin: 329.515,
                    }}
                    id="elsjpg9iwse8"
                    fill="#FFF"
                    d="M301.93 70.89H357.1V146.06H301.93z"
                    className="animable"
                ></path>
                <path
                    d="M360 148.93V68h-60.9v80.91zm-58-78h55.16v75.17h-55.23z"
                    style={{
                        WebkitTransformOrigin: 329.55,
                        MsTransformOrigin: 329.55,
                        transformOrigin: 329.55,
                    }}
                    id="el2tjw34k9jf9"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 327.395,
                        MsTransformOrigin: 327.395,
                        transformOrigin: 327.395,
                    }}
                    id="el0mrs77mwdqw"
                    fill="#EBEBEB"
                    d="M307.86 79.61H346.93V122.61H307.86z"
                    className="animable"
                    transform="rotate(-90)"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 329.505,
                        MsTransformOrigin: 329.505,
                        transformOrigin: 329.505,
                    }}
                    id="elppagmfkazae"
                    fill="#C7C7C7"
                    d="M308.49 97.46H350.52V119.49H308.49z"
                    className="animable"
                    transform="rotate(-90)"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 297.875,
                        MsTransformOrigin: 297.875,
                        transformOrigin: 297.875,
                    }}
                    id="el27j8437qjkw"
                    fill="#DBDBDB"
                    d="M296.7 68.02H299.05V148.93H296.7z"
                    className="animable"
                    transform="rotate(180)"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 251.175,
                        MsTransformOrigin: 251.175,
                        transformOrigin: 251.175,
                    }}
                    id="eludvoprws5wp"
                    fill="#FFF"
                    d="M223.59 70.89H278.76V146.06H223.59z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 262.07,
                        MsTransformOrigin: 262.07,
                        transformOrigin: 262.07,
                    }}
                    id="elkcftdprikrs"
                    fill="#C7C7C7"
                    d="M254.87 75.62H269.27V137.23000000000002H254.87z"
                    className="animable"
                ></path>
                <path
                    d="M281.63 148.93V68h-60.91v80.91zm-58-78h55.17v75.17h-55.21z"
                    style={{
                        WebkitTransformOrigin: 251.175,
                        MsTransformOrigin: 251.175,
                        transformOrigin: 251.175,
                    }}
                    id="elswjpki0bdz"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 251.175,
                        MsTransformOrigin: 251.175,
                        transformOrigin: 251.175,
                    }}
                    id="elvmoml8eb6rn"
                    fill="#EBEBEB"
                    d="M240.16 87.46H262.19V129.49H240.16z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 219.545,
                        MsTransformOrigin: 219.545,
                        transformOrigin: 219.545,
                    }}
                    id="elgkdhfzcudw"
                    fill="#DBDBDB"
                    d="M218.37 68.02H220.72V148.93H218.37z"
                    className="animable"
                    transform="rotate(180)"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 172.845,
                        MsTransformOrigin: 172.845,
                        transformOrigin: 172.845,
                    }}
                    id="elxm0sn6xxbnn"
                    fill="#FFF"
                    d="M145.26 70.89H200.43V146.06H145.26z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 179.175,
                        MsTransformOrigin: 179.175,
                        transformOrigin: 179.175,
                    }}
                    id="elxslkhiy23la"
                    fill="#EBEBEB"
                    d="M164.04 120.44H194.31V138.54H164.04z"
                    className="animable"
                ></path>
                <path
                    d="M203.3 148.93V68h-60.91v80.91zm-58-78h55.17v75.17h-55.21z"
                    style={{
                        WebkitTransformOrigin: 172.845,
                        MsTransformOrigin: 172.845,
                        transformOrigin: 172.845,
                    }}
                    id="el9saee2woe8b"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 172.845,
                        MsTransformOrigin: 172.845,
                        transformOrigin: 172.845,
                    }}
                    id="el3e1z8uvuema"
                    fill="#C7C7C7"
                    d="M161.83 87.46H183.86V129.49H161.83z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 141.215,
                        MsTransformOrigin: 141.215,
                        transformOrigin: 141.215,
                    }}
                    id="eljzwwekuwfun"
                    fill="#DBDBDB"
                    d="M140.04 68.02H142.39V148.93H140.04z"
                    className="animable"
                    transform="rotate(180)"
                ></path>
            </g>
            <g
                id="freepik--Floor--inject-2"
                style={{
                    WebkitTransformOrigin: 250,
                    MsTransformOrigin: 250,
                    transformOrigin: 250,
                }}
                className="animable"
            >
                <path
                    d="M48.57 453.83c129.05-.61 273.81-.62 402.86 0-129 .62-273.81.61-402.86 0z"
                    style={{
                        WebkitTransformOrigin: 250,
                        MsTransformOrigin: 250,
                        transformOrigin: 250,
                    }}
                    id="el4ck6dvlv0g4"
                    fill="#263238"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--Plant--inject-2"
                style={{
                    WebkitTransformOrigin: 387.454,
                    MsTransformOrigin: 387.454,
                    transformOrigin: 387.454,
                }}
                className="animable"
            >
                <path
                    d="M376.17 308a101.88 101.88 0 012.37-16.67c1.17-4.93 2.84-10 5.95-14.06 2.85-3.72 6.93-6.69 11.68-7.27 4.57-.56 8.86 1.48 12.28 4.36 4.24 3.57 7.48 8.29 10.53 12.87a156.39 156.39 0 019.09 15.92c.09.18-.18.33-.27.15a99 99 0 00-8.13-13.32 84.12 84.12 0 00-9.37-11.34c-3.14-3.06-7.12-5.93-11.67-6.07s-8.7 2.39-11.43 5.88c-3 3.9-4.59 8.77-5.75 13.51a101.27 101.27 0 00-2.35 15.87c-.89 11-1.13 22-1.38 33-.14 6.23-.22 12.46-.28 18.69q0 4.74-.08 9.47a58 58 0 01-.36 9.14c-.11.61-1.11.55-1.21 0a54.39 54.39 0 01-.42-8.66q-.06-4.49-.11-9c-.05-5.82-.08-11.64-.06-17.46.03-11.69.17-23.41.97-35.01z"
                    style={{
                        WebkitTransformOrigin: 401.641,
                        MsTransformOrigin: 401.641,
                        transformOrigin: 401.641,
                    }}
                    id="el54fdjl3f9b4"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M391.86 299.67c.58-3.1 1.63-7.15 3.4-9.56 3.18-4.32 6.61-2.44 3.44 2.35a28.53 28.53 0 00-4.47 11.8s5.35 7.63 11.8 11.39c-.28-2.93-1.11-7.45-.54-11.8 1.24-9.43 6.95-8.9 5.54-1.41-1.14 6-1.6 12.39-1.29 15.15a32 32 0 006.89 3.38c-.37-1.09-.76-2.41-1.2-4-2.29-8.45 3.35-11.09 3.53-6.33a66.87 66.87 0 002.19 12c3.1 1 5.66 1.75 7.23 2.3a26.44 26.44 0 0110.62 7.21 33.16 33.16 0 007.21-9.32c-2-1.69-5.09-4.22-9.41-7.27-8.11-5.72-5.29-12.94 1.14-8.45 4.64 3.24 8.23 9.25 9.87 12.33a50.18 50.18 0 003.67-16.88c-6.36-6-22.11-14.3-17.36-14.3 4.27 0 13.82 6.26 17.33 8.68a42.62 42.62 0 00-.54-4.91c-6-3.93-25.48-10-22.38-11.8 3.42-1.93 17 4.36 21.12 6.36a24.67 24.67 0 00-3.6-7.46c-8.29-11.1-23.23-14.92-29.75-12.8-4.61 1.49-3.26 13.2-4.25 12.8-18.58-7.46-27.05-2.19-20.19 20.54zm45.42-1.28c1.31-1.59 7.39 3.08 5.63 5.64s-7.33-3.61-5.63-5.64zm-31.78-10c1.6 1-.76 6.93-3.23 5.14-2.1-1.53 1.62-6.15 3.23-5.12z"
                    style={{
                        WebkitTransformOrigin: 420.488,
                        MsTransformOrigin: 420.488,
                        transformOrigin: 420.488,
                    }}
                    id="elu35wnpet0rd"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M407.93 290.22c.84-1.65 1.71-3.3 2.66-4.89a29.42 29.42 0 013.06-4.44c-.26-.32-.52-.65-.79-1-.11-.13.08-.31.2-.19.31.36.6.72.9 1.08a.24.24 0 01.13.15c1.15 1.37 2.23 2.79 3.26 4.23a50.13 50.13 0 015.38 1.56c1.81.61 3.62 1.24 5.38 2 .19.07.09.38-.09.3-1.75-.78-3.52-1.53-5.34-2.14s-3.46-1-5.2-1.52c.57.8 1.12 1.6 1.66 2.42a64.3 64.3 0 019.51 3.88c3.22 1.53 6.31 3.31 9.39 5.09.18.1 0 .37-.16.26-3-1.8-6.16-3.34-9.34-4.83-3-1.39-6.07-2.54-9.07-3.87 7.56 11.81 12.1 25.43 18.17 38.05.09.18-.2.33-.28.15-1.85-4.42-4-8.73-6-13.09-1.81-3.9-3.58-7.83-5.39-11.74-.53-1.14-1.08-2.28-1.63-3.42.33 6.31.2 12.72 1.23 19a.16.16 0 11-.31 0c-.44-6.74-1.63-13.37-1.58-20.15v-.09c-1.28-2.58-2.65-5.12-4.13-7.59-2.51 5.9-5.14 11.89-6.31 18.23 0 .19-.36.11-.3-.09 1.7-6.35 3.28-12.71 6.34-18.59a71 71 0 00-5.33-7.68c-.84 1.57-1.92 3.05-2.87 4.55s-1.85 2.94-2.71 4.45a63.93 63.93 0 00-4.74 10c-.07.19-.38.09-.3-.09 1.48-3.35 2.95-6.73 4.6-9.99z"
                    style={{
                        WebkitTransformOrigin: 420.716,
                        MsTransformOrigin: 420.716,
                        transformOrigin: 420.716,
                    }}
                    id="el8riisub0srt"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M348.29 304.58c4.85-4.87 10.5-11.26 18-11.25 7.24 0 12.57 5.84 15.63 11.86 3.21 6.29 4.36 13.42 5.26 20.34a249.4 249.4 0 011.92 25c.13 4.64.11 9.29 0 13.93a93.27 93.27 0 01-1.1 14.09.7.7 0 01-1.39 0c-.22-3.91-.06-7.83 0-11.75s0-7.71-.18-11.56c-.28-7.79-.85-15.57-1.77-23.32-.79-6.76-1.43-13.72-3.45-20.25-1.83-5.93-5.21-12.67-11.21-15.26-8.15-3.54-16.12 2.92-21.45 8.37-.16.14-.41-.06-.26-.2z"
                    style={{
                        WebkitTransformOrigin: 368.717,
                        MsTransformOrigin: 368.717,
                        transformOrigin: 368.717,
                    }}
                    id="el2b8d1ivfdv6"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M323.51 315.46c0 1 .1 2 .17 2.94a17.55 17.55 0 017.95-3.3c6.89-.73 6.45 4.51 1.85 4.73a26.22 26.22 0 00-9.46 1.9c1.13 9.09 3.63 16.41 4 16.51a133.64 133.64 0 0018.21-2.3c-1.72-3.65-5.62-8.51-3.63-8.9s4.16 3.93 5.26 8.57a87.13 87.13 0 0013.26-3.61c-3-2.62-7.72-5.89-5.93-7.28s5.51 3.21 7.74 6.55a27.14 27.14 0 005.72-3.19c-4.08-6-14-7.22-12.74-11.56s10.62 1.68 14.8 9.71c4.91-5.09 6.35-12.3 5.83-18.46-4.28-.5-12.51.41-11.91-2.67.56-2.92 6.54-2.48 11.41-.69a17.18 17.18 0 00-2.86-6.77c-4.51-5.79-18.26 1.57-18.26 1.57s1.47-13.82-3.78-16.21c-3-1.38-8.36-1.37-13.71 1.79 3 .24 6.63 1.2 8.09 3.28 1.86 2.66-1.08 4.1-2.95 2.88-1.32-.87-3.78-3.61-8.22-4a27.46 27.46 0 00-5 5.5c-.5.71-1 1.47-1.45 2.28a18.93 18.93 0 0116.1.27c6 3 2.63 9.15-2.5 6.74s-10-4.77-15.46-3.4c-2 4.6-2.66 10.05-2.61 15.42a26.9 26.9 0 018.83-4.25c5.93-1.55 7.72 2 1.21 2.65a26.15 26.15 0 00-9.96 3.3zm7.22-9.52c-.41-1.92 3.79-2.47 4.49-.92.59 1.33-4.09 2.84-4.49.92zm36 10.64c.4-1.05 3.22.14 3 1.45-.42 1.74-3.41-.4-3.03-1.45zm-19.86 6.74c2.05-.82 5.26 4.28 3 5.44s-4.7-4.76-3.03-5.44z"
                    style={{
                        WebkitTransformOrigin: 350.034,
                        MsTransformOrigin: 350.034,
                        transformOrigin: 350.034,
                    }}
                    id="elwxnpx0nvn6"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M328.83 337.2c3.09-5.17 6.15-10.36 9.39-15.43 1.51-2.37 3.09-4.68 4.74-6.95-.25-.05-.5-.13-.74-.18l-1.23-.23c-.95-.17-1.9-.31-2.86-.4s-1.81-.14-2.72-.15a12.8 12.8 0 00-2.9.15c-.11 0-.13-.16 0-.16 1 0 1.95-.08 2.92-.1s1.88 0 2.82.07 1.75.14 2.63.27c.48.08 1 .16 1.44.26a6.58 6.58 0 01.86.18q2.52-3.45 5.21-6.77a61.93 61.93 0 00-16.91-5.4c-.1 0-.07-.17 0-.15a57.14 57.14 0 0117.16 5.21c1-1.22 2-2.42 3-3.63s2.31-2.65 3.32-4.08c.07-.09.2 0 .13.09a58.66 58.66 0 00-3.93 4.8 58.67 58.67 0 016.29 5.05c2.06 1.82 4.07 3.71 6 5.64.08.07 0 .19-.1.11-1.93-1.91-3.93-3.74-6-5.47s-4.28-3.33-6.38-5.05l-1.44 1.89-.73.95a.18.18 0 01-.05.07q-1.2 1.56-2.4 3.15a24.8 24.8 0 012.39 4.31c.69 1.45 1.3 3 1.85 4.48a65.75 65.75 0 012.58 9.68c0 .1-.13.14-.15 0a56.21 56.21 0 00-2.82-9.49c-.6-1.58-1.28-3.12-2-4.66-.64-1.39-1.41-2.74-2-4.15-.69.92-1.38 1.85-2.06 2.78-.19.27-.38.55-.58.82 0 .06 0 .14-.07.14-2.12 3-4.14 6-6.11 9.07a2.61 2.61 0 01.27.67c.13.37.25.75.36 1.13a22 22 0 01.54 2.3c.13.72.23 1.46.3 2.2a20.72 20.72 0 00.19 2.5c0 .12-.17.13-.15 0a8.31 8.31 0 00-.17-2.33c-.12-.8-.26-1.59-.45-2.38s-.36-1.42-.57-2.11c-.1-.35-.22-.7-.34-1.05-.06-.18-.15-.37-.21-.57q-1.38 2.16-2.73 4.35c-1.78 2.89-3.54 5.79-5.32 8.68-.1.16-.36.04-.27-.11z"
                    style={{
                        WebkitTransformOrigin: 346.147,
                        MsTransformOrigin: 346.147,
                        transformOrigin: 346.147,
                    }}
                    id="elqf9bf5tr18"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M376.49 376.88c.08-2.93.54-5.88.86-8.79s.65-5.85 1-8.78c.6-5.64.94-11.4 2.27-16.93a24.62 24.62 0 016.88-12.66 11.24 11.24 0 016.76-3.23 11.62 11.62 0 017.17 2.22 24.62 24.62 0 016 6.35 62.47 62.47 0 014.71 7.64c.05.1-.11.16-.16.07a39.09 39.09 0 00-10.18-11.4 12 12 0 00-6.41-2.68 8.71 8.71 0 00-6.22 2.48c-3.42 3-5.39 7.34-6.57 11.63-1.4 5.08-1.85 10.43-2.54 15.64-.42 3.1-.81 6.2-1.22 9.29s-.67 6.25-1.32 9.29a.52.52 0 01-1.03-.14z"
                    style={{
                        WebkitTransformOrigin: 394.318,
                        MsTransformOrigin: 394.318,
                        transformOrigin: 394.318,
                    }}
                    id="eltxs58tc3fjp"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M390.89 354.14a16.58 16.58 0 003.19 3.25c-.48-2.86-1.07-7.94.38-10.64 2.24-4.2 4.89-2.1 3.55 1.55a29.66 29.66 0 00-2.15 10.34 44.85 44.85 0 009.72 4.59 16.49 16.49 0 01-.32-5c.45-4.49 3.89-4.41 3 .26a28.34 28.34 0 00-.48 5.48 100.9 100.9 0 0015.16 3.42 44.14 44.14 0 006.28-11.17c-3.66-.91-11.05-1.12-10.89-3.73.21-3.51 7.37-.81 11.56 1.74a28 28 0 001.27-9.45 47 47 0 00-10.08-1.67c-7.52-.65-7.15-4.91-1.7-4.82 4 .08 9.11 2.54 11.52 3.82-1.57-10.23-9.37-16.79-15.63-17-10.52-.42-6.73 12.67-6.73 12.67s-7.13-5-13.86-4.88-10.98 11.23-3.79 21.24zM419 335.21c-.23-1.47 4.46-1.82 4.71.07.29 2.12-4.48 1.43-4.71-.07zm7.55 15.36c-.09-1 1.93-1.13 2.39.08.3.79-2.31.87-2.4-.08zm-25.26.9c1.59.22 2.49 5.89-.24 5.78-2.05-.09-1.11-5.97.23-5.78z"
                    style={{
                        WebkitTransformOrigin: 409.167,
                        MsTransformOrigin: 409.167,
                        transformOrigin: 409.167,
                    }}
                    id="eljautla147lk"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M403.48 357.76c.26-.7.49-1.42.72-2.14-.21.73-.39 1.46-.53 2.2-.02.18-.24.08-.19-.06z"
                    style={{
                        WebkitTransformOrigin: 403.836,
                        MsTransformOrigin: 403.836,
                        transformOrigin: 403.836,
                    }}
                    id="elsygv1fdnjo"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M406.26 348.65c.49-1.45 1-2.89 1.61-4.32.3-.76.61-1.51.94-2.26a9.88 9.88 0 01.94-1.9 14.54 14.54 0 01-.85-1.84c0-.05.06-.1.1-.05a22.41 22.41 0 012.05 3.18c.29.49.57 1 .85 1.5a15.13 15.13 0 011.77.27l1.89.39 1.87.43c.62.15 1.24.36 1.87.45.14 0 .08.25-.05.2a12.4 12.4 0 00-2-.51c-.61-.13-1.21-.24-1.82-.33s-1.23-.16-1.84-.22c-.46-.05-.93-.07-1.39-.12.25.44.51.88.75 1.33a2.12 2.12 0 01.11.21 5.89 5.89 0 011.51.18c.55.09 1.09.2 1.63.32 1.1.24 2.19.5 3.27.8 2.28.64 4.53 1.36 6.77 2.1.13 0 .05.23-.08.19a63.35 63.35 0 00-6.8-1.89c-1.07-.24-2.15-.49-3.23-.72l-1.62-.34a10.9 10.9 0 01-1.26-.28c1.16 2.14 2.25 4.31 3.25 6.53 2.18 4.83 4 9.8 5.89 14.75.05.13-.14.21-.18.08a135.39 135.39 0 00-6.21-14.42c-.42-.86-.86-1.71-1.28-2.56 0 .17-.08.35-.11.52-.11.59-.21 1.17-.31 1.76-.2 1.17-.4 2.35-.57 3.52a41.06 41.06 0 00-.85 7.31c0 .16-.23.15-.2 0 .18-1.16.18-2.38.26-3.56s.17-2.46.31-3.68.29-2.37.48-3.54c.1-.59.2-1.17.31-1.76a3.61 3.61 0 01.33-1.27c-.62-1.24-1.23-2.48-1.85-3.71s-1.18-2.31-1.78-3.46c-.25-.48-.53-1-.8-1.46a14.72 14.72 0 01-.69 1.77l-.82 2c-.6 1.46-1.16 2.95-1.72 4.43-.8 2.1-1.68 4.26-2.33 6.45.62-2.12 1.16-4.35 1.88-6.47z"
                    style={{
                        WebkitTransformOrigin: 415.343,
                        MsTransformOrigin: 415.343,
                        transformOrigin: 415.343,
                    }}
                    id="elrtd0vrd6k7n"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M404.2 355.62c0-.17.1-.34.15-.51z"
                    style={{
                        WebkitTransformOrigin: 404.275,
                        MsTransformOrigin: 404.275,
                        transformOrigin: 404.275,
                    }}
                    id="el9fl56xwi8kc"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 382.365,
                        MsTransformOrigin: 382.365,
                        transformOrigin: 382.365,
                    }}
                    id="elomoch0pgba"
                    fill="#455A64"
                    d="M358.9 371.18L359.64 386.84 361.55 447.2 403.19 447.2 405.09 386.84 405.83 371.18 358.9 371.18z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 382.365,
                        MsTransformOrigin: 382.365,
                        transformOrigin: 382.365,
                    }}
                    id="el02difqtc4so4"
                    fill="#37474F"
                    d="M358.9 371.18L359.37 381.09 405.31 382.2 405.83 371.18 358.9 371.18z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 382.365,
                        MsTransformOrigin: 382.365,
                        transformOrigin: 382.365,
                    }}
                    id="elck5muilfsl"
                    fill="#455A64"
                    d="M355.94 364.85H408.79V377.51000000000005H355.94z"
                    className="animable"
                    transform="rotate(180)"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 396.155,
                        MsTransformOrigin: 396.155,
                        transformOrigin: 396.155,
                    }}
                    id="elpjm2vub3u7"
                    fill="#455A64"
                    d="M392.5 447.2H399.81V453.83H392.5z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 396.155,
                        MsTransformOrigin: 396.155,
                        transformOrigin: 396.155,
                    }}
                    id="elrmo5rled1xf"
                    fill="#37474F"
                    d="M392.5 447.2H399.81V450.51H392.5z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 368.57,
                        MsTransformOrigin: 368.57,
                        transformOrigin: 368.57,
                    }}
                    id="elayusa8sltq"
                    fill="#455A64"
                    d="M364.92 447.2H372.22V453.83H364.92z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 368.57,
                        MsTransformOrigin: 368.57,
                        transformOrigin: 368.57,
                    }}
                    id="elx5wr9ysihep"
                    fill="#37474F"
                    d="M364.92 447.2H372.22V450.51H364.92z"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--character-1--inject-2"
                style={{
                    WebkitTransformOrigin: 142.286,
                    MsTransformOrigin: 142.286,
                    transformOrigin: 142.286,
                }}
                className="animable"
            >
                <path
                    d="M138.42 130.36c6.6 24.89 17.77 49 25.73 50.9 9.64 2.29 13.61-24 12.27-24.71-1-.51-15.86-17.07-29.59-31.36-12.68-13.19-10.05-.99-8.41 5.17z"
                    style={{
                        WebkitTransformOrigin: 156.844,
                        MsTransformOrigin: 156.844,
                        transformOrigin: 156.844,
                    }}
                    id="elb3rmh8gv4dm"
                    fill="#D3766A"
                    className="animable"
                ></path>
                <path
                    d="M161.18 179.22c2.82 3.92 10.2 4.95 38.37 4.5 3.9-.06 8.85-28.55 4.68-28.69-5.25-.19-26.34 1.22-27.81 1.52-10.98 2.21-18.05 18.76-15.24 22.67z"
                    style={{
                        WebkitTransformOrigin: 183.188,
                        MsTransformOrigin: 183.188,
                        transformOrigin: 183.188,
                    }}
                    id="el8lvea2mcb7"
                    fill="#D3766A"
                    className="animable"
                ></path>
                <path
                    d="M193.82 183.62a87.2 87.2 0 0012 2.91c3.21.38 12.48 1.23 13.25-2.26.53-2.39-4.86-3.53-8.66-4.42-2-.47-4.63-2-4.28-3.34.62-2.26 5.78-.94 9.25.37 6.72 2.55 15.93 7.6 19.16 3.87 1.22-1.4-.78-3.27-3.53-5 4.3 1.8 8.79 3.12 10.21 1.6a2.09 2.09 0 000-2.86 2.78 2.78 0 002.93-1c1.05-1.54.11-3.39-1.61-5.17a1.5 1.5 0 001-.95c2-4.53-13.36-14.05-18.18-14.38a118.88 118.88 0 00-28.49 2c-4.65 5.24-3.06 28.62-3.05 28.63z"
                    style={{
                        WebkitTransformOrigin: 219.07,
                        MsTransformOrigin: 219.07,
                        transformOrigin: 219.07,
                    }}
                    id="elrp5f00j4w0h"
                    fill="#D3766A"
                    className="animable"
                ></path>
                <path
                    d="M211.82 167.72a23.52 23.52 0 019.7 2c3.84 1.71 6.58 4 9.93 6.22a.08.08 0 01-.09.14c-1.6-1.05-8.13-4.92-9.79-5.77a22.42 22.42 0 00-9.75-2.53v-.06z"
                    style={{
                        WebkitTransformOrigin: 221.654,
                        MsTransformOrigin: 221.654,
                        transformOrigin: 221.654,
                    }}
                    id="elb90u91vpid"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M213.41 161.5a55.94 55.94 0 0111.21 1.92c3.95 1.25 7.31 3.81 10.6 6.26 2 1.47 3.92 3 5.82 4.55.08.06 0 .2-.09.14-3.34-2.54-6.76-5-10.26-7.32a29.59 29.59 0 00-10.69-4.49c-2.19-.45-4.4-.72-6.61-1-.02 0-.02-.06.02-.06z"
                    style={{
                        WebkitTransformOrigin: 227.225,
                        MsTransformOrigin: 227.225,
                        transformOrigin: 227.225,
                    }}
                    id="elq4jt50fq2xp"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M216.41 155.8c3.6.14 6.75.25 10.15 1.6a50.73 50.73 0 0110.76 6.6c1.8 1.38 3.55 2.81 5.28 4.28.08.06 0 .18-.1.12a117.35 117.35 0 00-12.38-8.77 23.49 23.49 0 00-6.59-2.89 42.65 42.65 0 00-7.12-.89s-.02-.05 0-.05z"
                    style={{
                        WebkitTransformOrigin: 229.517,
                        MsTransformOrigin: 229.517,
                        transformOrigin: 229.517,
                    }}
                    id="eldbwl1redysh"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M176.42 156.55c-4.6 1.49-7.87 4.75-11.18 8.17 2.1-4.22 6.22-8.09 11.18-8.17z"
                    style={{
                        WebkitTransformOrigin: 170.83,
                        MsTransformOrigin: 170.83,
                        transformOrigin: 170.83,
                    }}
                    id="elc5ouy6um38i"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M144.43 151.44l25.06-6.31s-18.94-21.19-26.27-25.85c-8.24-5.25-9.12.12-7.18 9.2s8.39 22.96 8.39 22.96z"
                    style={{
                        WebkitTransformOrigin: 152.332,
                        MsTransformOrigin: 152.332,
                        transformOrigin: 152.332,
                    }}
                    id="eljp3ays5esoa"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M144 147c.84-.34 8.63-2.38 10.33-2.78s8.66-2.13 10.45-2.4a.07.07 0 010 .13c-1.71.6-8.71 2.35-10.44 2.8s-9.48 2.29-10.36 2.37c-.05.04-.06-.06.02-.12z"
                    style={{
                        WebkitTransformOrigin: 154.383,
                        MsTransformOrigin: 154.383,
                        transformOrigin: 154.383,
                    }}
                    id="elf2cq3e4lemu"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M164.78 146.31l-20.36 5.13s-6.44-13.88-8.39-23c-1.26-5.92-1.32-10.27 1.07-11.12z"
                    style={{
                        WebkitTransformOrigin: 149.975,
                        MsTransformOrigin: 149.975,
                        transformOrigin: 149.975,
                    }}
                    id="elulbqru9oc7h"
                    className="animable"
                    opacity="0.1"
                ></path>
                <path
                    d="M97.8 442.85c-2.39-.87-56.27-43.74-57.28-46.68-.41-1.11 41.1-53.74 41.1-53.74l33.08 27L88 404.67s13.28 25.64 14.06 29-1.88 10.05-4.26 9.18z"
                    style={{
                        WebkitTransformOrigin: 77.6085,
                        MsTransformOrigin: 77.6085,
                        transformOrigin: 77.6085,
                    }}
                    id="eltm9q5vg2pha"
                    fill="#D3766A"
                    className="animable"
                ></path>
                <path
                    d="M93.36 414.78c-.1-.15-.15-.25-.12-.29s.05.1.12.29z"
                    style={{
                        WebkitTransformOrigin: 93.2957,
                        MsTransformOrigin: 93.2957,
                        transformOrigin: 93.2957,
                    }}
                    id="elek3yw5omrog"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M97.91 443.9C95.49 443 41 399.21 40 396.23c-.39-1.13 5.54-10.19 13.75-18.88l35.11 28.27s12.69 25.56 13.46 28.95-2 10.22-4.41 9.33z"
                    style={{
                        WebkitTransformOrigin: 71.2165,
                        MsTransformOrigin: 71.2165,
                        transformOrigin: 71.2165,
                    }}
                    id="ely3s5gqadet"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M98.88 441.09c-9-7.57-45.8-37.23-55.23-44-.07-.06-.11 0 0 .06 8.71 7.69 45.79 37.06 55.15 44.12.2.12.26-.02.08-.18z"
                    style={{
                        WebkitTransformOrigin: 71.2845,
                        MsTransformOrigin: 71.2845,
                        transformOrigin: 71.2845,
                    }}
                    id="elh3pi71ppn85"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M100.35 429.8a9.42 9.42 0 00-7.26-2.16 9.13 9.13 0 00-6 3.23c0 .06.05.14.11.09a10.88 10.88 0 0113-1c.13.04.22-.1.15-.16z"
                    style={{
                        WebkitTransformOrigin: 93.7322,
                        MsTransformOrigin: 93.7322,
                        transformOrigin: 93.7322,
                    }}
                    id="elfivnxmhtfd"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M91 408.84c-3.62-3-8.89-5.11-13.57-3.94-.18 0-.11.3 0 .33a64.6 64.6 0 0113.23 4.11.3.3 0 00.34-.5z"
                    style={{
                        WebkitTransformOrigin: 84.226,
                        MsTransformOrigin: 84.226,
                        transformOrigin: 84.226,
                    }}
                    id="elzdn5trhpnr"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M92.89 412.21c-3.62-3-8.89-5.11-13.57-3.94-.18 0-.11.3 0 .33a64.79 64.79 0 0113.23 4.11.3.3 0 00.34-.5z"
                    style={{
                        WebkitTransformOrigin: 86.116,
                        MsTransformOrigin: 86.116,
                        transformOrigin: 86.116,
                    }}
                    id="elkco93een16c"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M94.83 415.58c-3.62-3-8.9-5.11-13.57-3.94-.18 0-.12.3 0 .33a64.79 64.79 0 0113.23 4.11.3.3 0 00.34-.5z"
                    style={{
                        WebkitTransformOrigin: 88.0544,
                        MsTransformOrigin: 88.0544,
                        transformOrigin: 88.0544,
                    }}
                    id="el1ddy4jxo0xwg"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M96.77 418.94c-3.62-3-8.9-5.1-13.57-3.93-.18 0-.12.3 0 .33a65 65 0 0113.23 4.1.3.3 0 00.34-.5z"
                    style={{
                        WebkitTransformOrigin: 89.9944,
                        MsTransformOrigin: 89.9944,
                        transformOrigin: 89.9944,
                    }}
                    id="el3ty8zqkn03d"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M53 390.25c-4.11-3.28-9.22 3.1-5.1 6.39s9.17-3.1 5.1-6.39z"
                    style={{
                        WebkitTransformOrigin: 50.4401,
                        MsTransformOrigin: 50.4401,
                        transformOrigin: 50.4401,
                    }}
                    id="elm8eu5hv1o1o"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M102.74 402.25c-.62-3-4.15-3.39-6.58-2.71a24.49 24.49 0 00-10.83 6.68.12.12 0 000 .19.58.58 0 00.42.83c4 .29 8.34 1.1 12.36.14 2.38-.56 5.22-2.27 4.63-5.13zM92 406.42c-2-.09-4-.28-6-.3a73.2 73.2 0 016.41-3.77 26.14 26.14 0 013.36-1.35c1.76-.57 7.81-.74 5 3.53-1.59 2.31-6.38 2.01-8.77 1.89z"
                    style={{
                        WebkitTransformOrigin: 94.044,
                        MsTransformOrigin: 94.044,
                        transformOrigin: 94.044,
                    }}
                    id="el1kms5fvc9sij"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M75.15 400.27c2.79 3.05 6.81 4.78 10.33 6.81a.57.57 0 00.81-.44.13.13 0 00.13-.15 24.66 24.66 0 00-5.23-11.61c-1.63-1.91-4.77-3.58-7-1.43s-.67 5.05.96 6.82zm-.53-3.85c0-5.13 4.95-1.6 6.1-.14a27.45 27.45 0 012 3c1.25 2.15 2.17 4.45 3.2 6.71-1.67-1.1-3.41-2.05-5.12-3.09-2.06-1.22-6.21-3.66-6.18-6.48z"
                    style={{
                        WebkitTransformOrigin: 79.7515,
                        MsTransformOrigin: 79.7515,
                        transformOrigin: 79.7515,
                    }}
                    id="elq1p1n1dpoir"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M64.49 364.29l34.17 27.35s56.55-66.73 58.62-76.75c2.36-11.39 8.91-100.62 8.76-105.07-.19-5.39-6.13-29.09-6.13-29.09h-42.36S111.63 297.42 110.4 301c-1.33 3.92-45.91 63.29-45.91 63.29z"
                    style={{
                        WebkitTransformOrigin: 115.266,
                        MsTransformOrigin: 115.266,
                        transformOrigin: 115.266,
                    }}
                    id="els109rnkov8"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M102 382.79c-5.46-5.27-26.76-22.19-29.41-23.57-.06 0-.14.07-.1.12 1.93 2.28 20.05 17.17 29.37 23.62.14.04.23-.09.14-.17z"
                    style={{
                        WebkitTransformOrigin: 87.2577,
                        MsTransformOrigin: 87.2577,
                        transformOrigin: 87.2577,
                    }}
                    id="el0dxu5a7dllw7"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M162 198.27a13.35 13.35 0 00-1.72-.4 11.51 11.51 0 01-1.79-.68 13.32 13.32 0 01-3.26-2.32 12.2 12.2 0 01-2.51-4c-.37-.85-2.1-5.4-2.12-5.43s-.17 0-.15.07c.12.63 1.3 4.55 1.65 5.53a12.86 12.86 0 002.62 4.69 10.48 10.48 0 003.62 2.44 8.09 8.09 0 001.94.52 3.13 3.13 0 001.77-.11c.1-.07.04-.27-.05-.31z"
                    style={{
                        WebkitTransformOrigin: 156.275,
                        MsTransformOrigin: 156.275,
                        transformOrigin: 156.275,
                    }}
                    id="eluvmp0w3tc5"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M124.54 182.8l-.89 23.43-1 23.43-2.26 46.85c-.42 7.81-.84 15.61-1.33 23.42 0 1-.13 2-.23 3a1.35 1.35 0 01-.09.45 2.55 2.55 0 01-.19.37l-.39.66c-.28.42-.56.82-.84 1.22-1.13 1.61-2.31 3.17-3.49 4.73-2.37 3.12-4.8 6.18-7.23 9.24q-7.32 9.18-14.73 18.26l-14.95 18.05 14.57-18.38c4.85-6.13 9.71-12.25 14.5-18.42q3.6-4.64 7.14-9.3c1.18-1.56 2.34-3.12 3.46-4.71q.42-.6.81-1.2c.23-.41.56-.81.54-1.15.08-.94.16-1.89.21-2.88.46-7.79.84-15.6 1.24-23.41l2.47-46.84 1.29-23.41z"
                    style={{
                        WebkitTransformOrigin: 100.73,
                        MsTransformOrigin: 100.73,
                        transformOrigin: 100.73,
                    }}
                    id="el7fu3jxy3d5w"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M158.13 308.67c-.31 2.88-.59 5-.85 6.22-1.16 5.63-19.51 29.14-35.37 48.68L111 295.16c1.94-24.28 6.52-114.44 6.52-114.44h21.11z"
                    style={{
                        WebkitTransformOrigin: 134.565,
                        MsTransformOrigin: 134.565,
                        transformOrigin: 134.565,
                    }}
                    id="elrf73bfhzdwn"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M217.55 441.52c-2.22 1.22-70 13.41-72.87 12.23-1.1-.43-13.24-66.35-13.24-66.35l42.09-7 8.88 43.34s28 6.94 31.05 8.56 6.32 8.01 4.09 9.22z"
                    style={{
                        WebkitTransformOrigin: 174.863,
                        MsTransformOrigin: 174.863,
                        transformOrigin: 174.863,
                    }}
                    id="elsxh2j75piwb"
                    fill="#D3766A"
                    className="animable"
                ></path>
                <path
                    d="M193.55 426.33c-.19 0-.29-.05-.31-.1z"
                    style={{
                        WebkitTransformOrigin: 193.395,
                        MsTransformOrigin: 193.395,
                        transformOrigin: 193.395,
                    }}
                    id="elip06x5dqou"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M218.73 441.74c-2.27 1.22-71.15 13.21-74.06 12-1.11-.45-4-10.89-5.09-22.8l44.42-7.67s27.57 7.37 30.63 9 6.37 8.24 4.1 9.47z"
                    style={{
                        WebkitTransformOrigin: 179.531,
                        MsTransformOrigin: 179.531,
                        transformOrigin: 179.531,
                    }}
                    id="elvu7ate8bj4d"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M217.26 439.16c-11.59 1.72-58.2 9.78-69.53 12.36-.09 0-.08.09 0 .08 11.53-1.46 58.07-9.9 69.56-12.26.25-.05.22-.22-.03-.18z"
                    style={{
                        WebkitTransformOrigin: 182.565,
                        MsTransformOrigin: 182.565,
                        transformOrigin: 182.565,
                    }}
                    id="elrnp5ocd71mn"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M209.76 430.59a9.44 9.44 0 00-6.42 4 9.19 9.19 0 00-1.51 6.62c0 .07.15 0 .14 0a10.89 10.89 0 017.81-10.46.08.08 0 00-.02-.16z"
                    style={{
                        WebkitTransformOrigin: 205.786,
                        MsTransformOrigin: 205.786,
                        transformOrigin: 205.786,
                    }}
                    id="elgxfdnaww0yk"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M187.82 423.8c-4.64.74-9.71 3.3-11.92 7.58-.09.17.15.29.27.19a65.56 65.56 0 0111.83-7.22.29.29 0 00-.18-.55z"
                    style={{
                        WebkitTransformOrigin: 182.031,
                        MsTransformOrigin: 182.031,
                        transformOrigin: 182.031,
                    }}
                    id="elijcrkfivjn"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M191.63 424.57c-4.64.74-9.71 3.3-11.92 7.58-.09.17.15.29.27.19a65.56 65.56 0 0111.83-7.22.29.29 0 00-.18-.55z"
                    style={{
                        WebkitTransformOrigin: 185.841,
                        MsTransformOrigin: 185.841,
                        transformOrigin: 185.841,
                    }}
                    id="el7d2d011bvhn"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M195.44 425.34c-4.64.74-9.71 3.3-11.92 7.58-.09.17.15.29.27.19a65.56 65.56 0 0111.83-7.22.29.29 0 00-.18-.55z"
                    style={{
                        WebkitTransformOrigin: 189.651,
                        MsTransformOrigin: 189.651,
                        transformOrigin: 189.651,
                    }}
                    id="eltb42zcoz7y"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M199.25 426.11c-4.64.74-9.71 3.3-11.92 7.58-.09.17.15.29.27.19a65.21 65.21 0 0111.83-7.22.29.29 0 00-.18-.55z"
                    style={{
                        WebkitTransformOrigin: 193.461,
                        MsTransformOrigin: 193.461,
                        transformOrigin: 193.461,
                    }}
                    id="el8td97ofbnw4"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M148.76 440c-5.18.92-3.76 9 1.43 8.06s3.81-8.93-1.43-8.06z"
                    style={{
                        WebkitTransformOrigin: 149.485,
                        MsTransformOrigin: 149.485,
                        transformOrigin: 149.485,
                    }}
                    id="elyukp6oimz3"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M190.67 410.6c-2.68-1.53-5.3.87-6.39 3.14a24.55 24.55 0 00-2.14 12.55c0 .1.09.12.16.11a.57.57 0 00.9.22c2.89-2.85 6.34-5.53 8.28-9.18 1.13-2.14 1.72-5.39-.81-6.84zm-4 10.81c-1.39 1.43-2.85 2.79-4.18 4.28a72.32 72.32 0 011.41-7.3 25.31 25.31 0 011.15-3.41c.73-1.71 4.6-6.36 5.93-1.41.78 2.73-2.62 6.13-4.27 7.84z"
                    style={{
                        WebkitTransformOrigin: 187.241,
                        MsTransformOrigin: 187.241,
                        transformOrigin: 187.241,
                    }}
                    id="el94ol01r0kn4"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M171 430c4.13-.08 8.09-1.95 11.93-3.25a.57.57 0 00.2-.9c0-.06.07-.15 0-.2a24.52 24.52 0 00-12.17-3.74c-2.51-.05-5.84 1.21-5.68 4.29.09 2.91 3.26 3.85 5.72 3.8zm-3.24-2.15c-3.82-3.42 2.07-4.77 3.92-4.66a26.92 26.92 0 013.57.51 71.73 71.73 0 017.15 2c-1.93.52-3.8 1.2-5.7 1.8-2.33.74-6.89 2.24-8.99.35z"
                    style={{
                        WebkitTransformOrigin: 174.274,
                        MsTransformOrigin: 174.274,
                        transformOrigin: 174.274,
                    }}
                    id="el3676toqq60e"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M151.48 180.73s-1.11 18.11-6.11 31c0 0-7.21 4.49-8 5.2l42.91 193.34-44 8.56S119 325.17 117.55 318.75c-2.36-10.31-21-98-21.87-102.94-1.73-10.42 7.89-35.08 7.89-35.08z"
                    style={{
                        WebkitTransformOrigin: 137.876,
                        MsTransformOrigin: 137.876,
                        transformOrigin: 137.876,
                    }}
                    id="el4ghquxpq8ul"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M175.83 400.62c-12.1 1.81-35.24 6.72-38.09 7.9-.06 0 0 .15 0 .15 3.09-.05 31.28-5.64 38.11-7.83a.11.11 0 00-.02-.22z"
                    style={{
                        WebkitTransformOrigin: 156.832,
                        MsTransformOrigin: 156.832,
                        transformOrigin: 156.832,
                    }}
                    id="elk6mf73nthz"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M109 198.28a27.21 27.21 0 012.72-.25 20.48 20.48 0 002.79-.53 20 20 0 005-2 10.7 10.7 0 003.64-3.86c.51-.83 2.85-5.28 2.88-5.31s.28 0 .25.08a58 58 0 01-2.13 5.46 10.47 10.47 0 01-3.75 4.52 16.53 16.53 0 01-5.55 2.13 17.6 17.6 0 01-3.06.35 8 8 0 01-2.84-.27c-.18-.1-.09-.29.05-.32z"
                    style={{
                        WebkitTransformOrigin: 117.566,
                        MsTransformOrigin: 117.566,
                        transformOrigin: 117.566,
                    }}
                    id="el0j8hwhc9fju6"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M146.42 211.25a73 73 0 00-11.6 5.28.13.13 0 00.1.24c3.91-1.64 7.89-3.2 11.7-5.05a.26.26 0 00-.2-.47z"
                    style={{
                        WebkitTransformOrigin: 140.738,
                        MsTransformOrigin: 140.738,
                        transformOrigin: 140.738,
                    }}
                    id="el2di73xi1tlw"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M147.9 184.56c0-.13-.25-.17-.25 0a129.41 129.41 0 01-.77 13c-.2 2-1.91 13.06-5.38 12.22-.58-.14-.87-.71-1-1.59a13.56 13.56 0 01.5-3.39c.4-2.32.73-4.64 1-7a63.13 63.13 0 000-13.11.11.11 0 00-.22 0 120.19 120.19 0 01-1.22 18.08c-.47 2.88-2 7.2 1.05 7.67s5.12-6.76 5.51-8.75a66.5 66.5 0 00.78-17.13z"
                    style={{
                        WebkitTransformOrigin: 143.946,
                        MsTransformOrigin: 143.946,
                        transformOrigin: 143.946,
                    }}
                    id="el03stu0s5kop9"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M141.59 210.06a18.82 18.82 0 00-.8 2.29 5.13 5.13 0 00-.34 1.89c0 .12.17.13.24 0a6.57 6.57 0 00.82-1.83c.27-.71.56-1.41.81-2.12a.39.39 0 00-.73-.23z"
                    style={{
                        WebkitTransformOrigin: 141.386,
                        MsTransformOrigin: 141.386,
                        transformOrigin: 141.386,
                    }}
                    id="elbqvni1hke3f"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M107.17 180.73q-1.8 6.89-3.37 13.83c-1 4.63-2 9.28-2.59 14l-.16 1.76v1.75l.52 3.49 1.32 7 2.84 14 11.63 55.75L129 348l5.78 27.88 5.71 27.9-6.19-27.8-6.06-27.82-11.87-55.7c-3.84-18.59-7.72-37.18-11.4-55.8l-2.7-14-1.26-7-.49-3.56a30.64 30.64 0 01.26-3.59c.67-4.72 1.73-9.35 2.83-14s2.28-9.21 3.56-13.78z"
                    style={{
                        WebkitTransformOrigin: 120.505,
                        MsTransformOrigin: 120.505,
                        transformOrigin: 120.505,
                    }}
                    id="els4p3el6ky5i"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M140.14 81.06c2.58-1.89 8.51-15.69-3.33-22.37-11.66-6.57-25.9 8.52-17.34 19.67 5.76 7.49 15.18 6.71 20.67 2.7z"
                    style={{
                        WebkitTransformOrigin: 130.391,
                        MsTransformOrigin: 130.391,
                        transformOrigin: 130.391,
                    }}
                    id="el2bxsuqvpcup"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M162.18 185.41l-1.89-17.75s7.05-11 3.68-19.33c-1.69-4.21-13.74-25-20.51-30.43-6.35-5.11-16.64-.9-19.91 3.11-9.41 11.52-14.54 22.65-21.39 61.44z"
                    style={{
                        WebkitTransformOrigin: 133.521,
                        MsTransformOrigin: 133.521,
                        transformOrigin: 133.521,
                    }}
                    id="elyaklwd089kc"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M149 164a62.26 62.26 0 00-9 1.11c-1.47.32-2.92.7-4.37 1.11-.72.21-1.45.39-2.18.57a9.64 9.64 0 01-2.33.34c-.07 0-.07.1 0 .11a16.57 16.57 0 002.23.05 15.43 15.43 0 002.13-.32c1.5-.3 3-.68 4.48-1 3-.64 6-1.29 9.09-1.72a.13.13 0 00-.05-.25z"
                    style={{
                        WebkitTransformOrigin: 140.099,
                        MsTransformOrigin: 140.099,
                        transformOrigin: 140.099,
                    }}
                    id="elzketdflfekl"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M156.32 167a67 67 0 00-7.48-.66c-1.25 0-2.49 0-3.74.07-.6 0-1.2.08-1.79.13s-1.31.2-2 .25c-.07 0-.07.11 0 .1.62 0 1.24.05 1.86.06h1.87c1.25 0 2.5.05 3.75.06 2.5 0 5 .06 7.48.16.18.06.17-.17.05-.17z"
                    style={{
                        WebkitTransformOrigin: 148.833,
                        MsTransformOrigin: 148.833,
                        transformOrigin: 148.833,
                    }}
                    id="elgpebsq96hnv"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M122.69 123c-20.36 15.77-40.62 45.14-37.45 53.46 3.53 9.26 26.58-7.39 26.68-8.9.08-1.13 11-20.61 18.81-38.82 7.21-16.84-3-9.66-8.04-5.74z"
                    style={{
                        WebkitTransformOrigin: 109.068,
                        MsTransformOrigin: 109.068,
                        transformOrigin: 109.068,
                    }}
                    id="eljt4z56enfzf"
                    fill="#D3766A"
                    className="animable"
                ></path>
                <path
                    d="M123.55 151.27l-24.84-7.14s19.64-20.55 27.12-25c8.41-5 9.11.42 6.87 9.44s-9.15 22.7-9.15 22.7z"
                    style={{
                        WebkitTransformOrigin: 116.252,
                        MsTransformOrigin: 116.252,
                        transformOrigin: 116.252,
                    }}
                    id="el8qptjzzki0f"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M124.14 146.88c-.82-.37-8.55-2.67-10.24-3.13s-8.57-2.41-10.35-2.74a.06.06 0 000 .12c1.68.66 8.62 2.65 10.33 3.15s9.4 2.6 10.28 2.72c.03 0 .03-.1-.02-.12z"
                    style={{
                        WebkitTransformOrigin: 113.836,
                        MsTransformOrigin: 113.836,
                        transformOrigin: 113.836,
                    }}
                    id="elixm59auzq4k"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M120.52 150.4c1 .2 2.06.44 3.08.68l-.23.1 3.79-8.25c1.13-2.42 2.7-5.86 3.86-8.23a83.46 83.46 0 01-7.29 16.67l-.09.15c-1-.36-2.09-.72-3.12-1.12z"
                    style={{
                        WebkitTransformOrigin: 125.77,
                        MsTransformOrigin: 125.77,
                        transformOrigin: 125.77,
                    }}
                    id="eln9jxo02ku6i"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M128.38 141.09a32.55 32.55 0 012.79-3.18 5.32 5.32 0 01-2.79 3.18z"
                    style={{
                        WebkitTransformOrigin: 129.775,
                        MsTransformOrigin: 129.775,
                        transformOrigin: 129.775,
                    }}
                    id="elbnds90s42qd"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M86.27 177.92C88.73 182.07 97 187 125 189.07c3.89.29 11.35-27.65 7.21-28.16-5.21-.65-22.73-1.13-24.22-1-11.1 1.27-24.17 13.86-21.72 18.01z"
                    style={{
                        WebkitTransformOrigin: 109.698,
                        MsTransformOrigin: 109.698,
                        transformOrigin: 109.698,
                    }}
                    id="elmfzyktk5o1a"
                    fill="#D3766A"
                    className="animable"
                ></path>
                <path
                    d="M122.7 161.69s10.61-.87 17.72-.85c4 0 10.76.62 13.67 2 4.36 2 21.29 13.15 18.68 17.32-2.37 3.77-15.7-7.66-15.7-7.66s14.47 10.34 10.78 14.36-17-10.9-17-10.9 14.63 11 10.18 14.49c-3.37 2.68-16.22-10.15-16.22-10.15s12.51 9.51 9.17 12.41c-3.69 3.2-16.3-7.9-16.3-7.9-9.74 5.94-16.8 4.78-21.73 3.36-1.23-.38 6.75-26.48 6.75-26.48z"
                    style={{
                        WebkitTransformOrigin: 144.432,
                        MsTransformOrigin: 144.432,
                        transformOrigin: 144.432,
                    }}
                    id="eleza78eqvx5g"
                    fill="#D3766A"
                    className="animable"
                ></path>
                <path
                    d="M152.29 168.56c1.75 1.16 3.52 2.31 5.15 3.62s3.23 2.66 4.74 4.11a35.5 35.5 0 015.32 6.21c-3-3.82-8.79-8.58-10.43-9.89s-3.2-2.68-4.83-4c-.04-.02.01-.08.05-.05z"
                    style={{
                        WebkitTransformOrigin: 159.863,
                        MsTransformOrigin: 159.863,
                        transformOrigin: 159.863,
                    }}
                    id="elb8b0akl7umg"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M147.47 174.38c2.17 1.57 4.37 3.05 6.47 4.71s3.91 3.42 5.88 5.21c.15.14 0 .18-.13 0-2-1.71-4.05-3.14-6.11-4.84s-4-3.46-6.15-5.07l.04-.01z"
                    style={{
                        WebkitTransformOrigin: 153.656,
                        MsTransformOrigin: 153.656,
                        transformOrigin: 153.656,
                    }}
                    id="elnepngwmifip"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M142.44 178.63a60 60 0 019.33 8c.15.15 0 .18-.18 0-3.05-2.71-5.42-4.85-9.23-7.88-.06-.05.01-.16.08-.12z"
                    style={{
                        WebkitTransformOrigin: 147.084,
                        MsTransformOrigin: 147.084,
                        transformOrigin: 147.084,
                    }}
                    id="elr4qlfbq6kuc"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M137 160.89a90.91 90.91 0 0114 .72 11.35 11.35 0 013.39 1.07 69.33 69.33 0 019 5.52c2.6 2 13 9.1 9.12 12.69-2.72 1.8-8.3-2.33-10.45-4.06l.27-.31c2.25 2.34 5.08 4.68 6.07 7.85-1.12-3.13-4.05-5.27-6.34-7.54l.27-.31c2 1.56 7.31 5.23 9.76 3.87 3.1-3-6.92-9.88-9.12-11.62-3.75-2.48-7.6-5.66-12-6.65a110.78 110.78 0 00-13.97-1.23z"
                    style={{
                        WebkitTransformOrigin: 155.184,
                        MsTransformOrigin: 155.184,
                        transformOrigin: 155.184,
                    }}
                    id="elcbuk9hkg7dm"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M128.86 160.56c-2.57 0-5.13-.13-7.7-.2s-5.12-.19-7.68-.19a31.59 31.59 0 00-7.59.49 66.84 66.84 0 00-7.43 1.89 39.87 39.87 0 017.3-2.52 30.05 30.05 0 017.73-.69c2.58.07 5.15.18 7.71.39s5.12.46 7.66.83z"
                    style={{
                        WebkitTransformOrigin: 113.66,
                        MsTransformOrigin: 113.66,
                        transformOrigin: 113.66,
                    }}
                    id="el3cn941s9lq"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M132.16 118.45c.15 1.14 15 20.11 18.48 20.32 1.94.12-6.16-19-6.16-19l3.27-9.91-11.92-9.33s-3.73 17.47-3.67 17.92z"
                    style={{
                        WebkitTransformOrigin: 141.55,
                        MsTransformOrigin: 141.55,
                        transformOrigin: 141.55,
                    }}
                    id="el1g5t6dzfifv"
                    fill="#D3766A"
                    className="animable"
                ></path>
                <path
                    d="M134.46 107a19.92 19.92 0 0010.2 12.16l3.09-9.36-11.92-9.33z"
                    style={{
                        WebkitTransformOrigin: 141.105,
                        MsTransformOrigin: 141.105,
                        transformOrigin: 141.105,
                    }}
                    id="elr9udusuhu6p"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M162.13 95.14c1 17.06-9.07 19.61-12.75 19.83-3.34.2-14.74.45-17.54-16.41s4.81-22.75 12.43-23.56 16.82 3.07 17.86 20.14z"
                    style={{
                        WebkitTransformOrigin: 146.723,
                        MsTransformOrigin: 146.723,
                        transformOrigin: 146.723,
                    }}
                    id="el2d6nflzsubn"
                    fill="#D3766A"
                    className="animable"
                ></path>
                <path
                    d="M158.52 92a11.3 11.3 0 01-1.16-.22 1.86 1.86 0 01-1.14-.45.6.6 0 010-.74 1.53 1.53 0 011.48-.39 2.23 2.23 0 011.41.75.66.66 0 01-.59 1.05z"
                    style={{
                        WebkitTransformOrigin: 157.666,
                        MsTransformOrigin: 157.666,
                        transformOrigin: 157.666,
                    }}
                    id="eluftouwuodv"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M147.16 92.37c.4-.06.76-.18 1.15-.27a1.92 1.92 0 001.12-.5.62.62 0 000-.75 1.51 1.51 0 00-1.49-.31 2.2 2.2 0 00-1.37.82.64.64 0 00.59 1.01z"
                    style={{
                        WebkitTransformOrigin: 148.003,
                        MsTransformOrigin: 148.003,
                        transformOrigin: 148.003,
                    }}
                    id="eli16mtx4m2e"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M149.71 96.63s-.09.06-.08.11c.09 1.16 0 2.5-1 2.94v.06c1.25-.24 1.37-2.02 1.08-3.11z"
                    style={{
                        WebkitTransformOrigin: 149.236,
                        MsTransformOrigin: 149.236,
                        transformOrigin: 149.236,
                    }}
                    id="elcssx7rjkiwf"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M148.62 95.46c-1.88 0-1.85 3.71-.11 3.76s1.68-3.71.11-3.76z"
                    style={{
                        WebkitTransformOrigin: 148.507,
                        MsTransformOrigin: 148.507,
                        transformOrigin: 148.507,
                    }}
                    id="elcvw0lsbre8h"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M147.88 95.67c-.33.21-.65.59-1 .64s-.81-.35-1.11-.72h-.06c0 .72.27 1.46 1.05 1.56s1.2-.55 1.38-1.28c-.01-.09-.14-.29-.26-.2z"
                    style={{
                        WebkitTransformOrigin: 146.925,
                        MsTransformOrigin: 146.925,
                        transformOrigin: 146.925,
                    }}
                    id="elghcj7gqugvf"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M156.37 96.33s.09.06.09.1c0 1.17.12 2.51 1.17 2.89v.07c-1.3-.18-1.48-1.96-1.26-3.06z"
                    style={{
                        WebkitTransformOrigin: 156.96,
                        MsTransformOrigin: 156.96,
                        transformOrigin: 156.96,
                    }}
                    id="elq9lnbw14zs"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M157.41 95.11c1.87-.14 2 3.62.28 3.75s-1.85-3.62-.28-3.75z"
                    style={{
                        WebkitTransformOrigin: 157.606,
                        MsTransformOrigin: 157.606,
                        transformOrigin: 157.606,
                    }}
                    id="elt4actewbfa"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M158.2 95.33c.3.19.61.54 1 .55s.7-.41.94-.81h.06c.05.72-.15 1.47-.84 1.64s-1.11-.45-1.31-1.16c-.05-.09.03-.29.15-.22z"
                    style={{
                        WebkitTransformOrigin: 159.121,
                        MsTransformOrigin: 159.121,
                        transformOrigin: 159.121,
                    }}
                    id="elqhubsuc3w3m"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M149.85 106.2c.26.29.5.69.92.76a2.92 2.92 0 001.27-.19l.05.07a1.57 1.57 0 01-1.53.5 1.23 1.23 0 01-.82-1.1c-.02-.07.08-.08.11-.04z"
                    style={{
                        WebkitTransformOrigin: 150.914,
                        MsTransformOrigin: 150.914,
                        transformOrigin: 150.914,
                    }}
                    id="el7d1iv7e95bp"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M154.83 102.12s.19 1.74.17 2.56c0 .08-.2.11-.48.12a3.9 3.9 0 01-3.75-1.56c-.05-.08 0-.16.13-.11a5.86 5.86 0 003.53 1.12c.06-.23-.43-3-.3-3a7.86 7.86 0 011.85.47c-.3-3.64-1.18-7.21-1.43-10.84a.11.11 0 01.22 0 59.32 59.32 0 012 11.62c.06.43-1.62-.23-1.94-.38z"
                    style={{
                        WebkitTransformOrigin: 153.761,
                        MsTransformOrigin: 153.761,
                        transformOrigin: 153.761,
                    }}
                    id="el8yf25extnbq"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M154 104.63a4.29 4.29 0 01-1.68 1.33 2 2 0 01-1.16.08c-.84-.21-.86-1-.71-1.64a4.59 4.59 0 01.36-1 5.46 5.46 0 003.19 1.23z"
                    style={{
                        WebkitTransformOrigin: 152.189,
                        MsTransformOrigin: 152.189,
                        transformOrigin: 152.189,
                    }}
                    id="elbh5l1zi8wum"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M152.36 106a2 2 0 01-1.16.08c-.84-.21-.86-1-.71-1.64a2 2 0 011.87 1.56z"
                    style={{
                        WebkitTransformOrigin: 151.389,
                        MsTransformOrigin: 151.389,
                        transformOrigin: 151.389,
                    }}
                    id="el4qfh7h9aoqs"
                    fill="#FF9BBC"
                    className="animable"
                ></path>
                <path
                    d="M151.2 78.3a7.63 7.63 0 01-.21 4.46c-1.84 3.85-6.46 2.83-8 4.35s-1 4.38-2.3 5.81c-1.86 2-4.38 1.2-4.69 2.54s-1.19 5.56-2.88 6.1-9.42-27.66 12.65-26.74c0 0 3-1.24 7.73 1.14 5.19 2.64 7.44 11.21 7.44 11.21s-.12-.12-.87-.79c-1.06-.94-1.48-1.82-2.26-2.43-1.22-1-1.89-.6-3.17-1.54a14.64 14.64 0 01-3.44-4.11z"
                    style={{
                        WebkitTransformOrigin: 145.687,
                        MsTransformOrigin: 145.687,
                        transformOrigin: 145.687,
                    }}
                    id="eln8c3s9cvpv"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M150.86 77.07a14.61 14.61 0 01.65 3.39 6.33 6.33 0 01-.48 3.3 4.52 4.52 0 01-2.53 2c-1.05.39-2.21.5-3.34 1a3.5 3.5 0 00-1.48 1.12 4.67 4.67 0 00-.65 1.7 6 6 0 01-1.23 3.07 3.8 3.8 0 01-3 1.24c-1.11 0-2.34-.31-3.42.18 1.12-.4 2.25 0 3.42.09a4.17 4.17 0 003.27-1.22 6.2 6.2 0 001.4-3.25 4.3 4.3 0 01.59-1.51 3 3 0 011.27-.91c1-.43 2.19-.57 3.3-1a5.85 5.85 0 001.57-.86 3.59 3.59 0 001.21-1.41 6.55 6.55 0 00.36-3.52 14.91 14.91 0 00-.91-3.41z"
                    style={{
                        WebkitTransformOrigin: 143.623,
                        MsTransformOrigin: 143.623,
                        transformOrigin: 143.623,
                    }}
                    id="el2iiuwlrg9ty"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M151.29 78.08a12.08 12.08 0 001.06 3.06 5.76 5.76 0 002.22 2.45 8.48 8.48 0 001.52.59 2.66 2.66 0 011.19.81 8.28 8.28 0 001 1.31 3.7 3.7 0 001.4.82 4 4 0 01-1.2-1 8.57 8.57 0 01-.81-1.36 2.77 2.77 0 00-1.36-1.06 8.17 8.17 0 01-1.44-.59 6 6 0 01-2.09-2.19 23 23 0 01-1.49-2.84z"
                    style={{
                        WebkitTransformOrigin: 155.485,
                        MsTransformOrigin: 155.485,
                        transformOrigin: 155.485,
                    }}
                    id="elv6s4skbpd4"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M135.2 99.51s-3.87-5.24-6.26-3.84.62 9 3.49 10a2.89 2.89 0 003.83-1.65z"
                    style={{
                        WebkitTransformOrigin: 132.167,
                        MsTransformOrigin: 132.167,
                        transformOrigin: 132.167,
                    }}
                    id="eluq21i1ipq7e"
                    fill="#D3766A"
                    className="animable"
                ></path>
                <path
                    d="M129.86 97.84v.08c2 .75 3.12 2.57 3.9 4.47a1.6 1.6 0 00-2.4-.38c-.05 0 0 .12.06.11a1.77 1.77 0 012 .57 8.36 8.36 0 011 1.56c.1.17.42.07.34-.14-.1-2.58-2.17-6.11-4.9-6.27z"
                    style={{
                        WebkitTransformOrigin: 132.316,
                        MsTransformOrigin: 132.316,
                        transformOrigin: 132.316,
                    }}
                    id="elyyzpvt6opys"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 142.43,
                        MsTransformOrigin: 142.43,
                        transformOrigin: 142.43,
                    }}
                    id="eldzn09fevty"
                    fill="#578AD6"
                    d="M132.16 118.44L150.63 138.77 144.48 119.73 151.88 126.76 149.46 128.25 152.7 131.25 152.07 141.73 138.59 133.61 140.09 129.68 134.73 129.41 132.16 118.44z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 142.43,
                        MsTransformOrigin: 142.43,
                        transformOrigin: 142.43,
                    }}
                    id="elrvxzse8jds9"
                    fill="#FFF"
                    d="M132.16 118.44L150.63 138.77 144.48 119.73 151.88 126.76 149.46 128.25 152.7 131.25 152.07 141.73 138.59 133.61 140.09 129.68 134.73 129.41 132.16 118.44z"
                    className="animable"
                    opacity="0.5"
                ></path>
            </g>
            <g
                id="freepik--character-2--inject-2"
                style={{
                    WebkitTransformOrigin: 290.436,
                    MsTransformOrigin: 290.436,
                    transformOrigin: 290.436,
                }}
                className="animable"
            >
                <path
                    d="M206 375.57c0-42 27.38-76.17 61-76.17s61 34.17 61 76.17-27.38 76.17-61 76.17-61-34.17-61-76.17zm6.11 0c0 38.63 24.64 70.06 54.92 70.06s54.92-31.43 54.92-70.06-24.69-70.06-54.95-70.06-54.94 31.43-54.94 70.06z"
                    style={{
                        WebkitTransformOrigin: 267,
                        MsTransformOrigin: 267,
                        transformOrigin: 267,
                    }}
                    id="eliy4nd5u8uys"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M208.17 375.57c0-37.23 24.22-67.52 54-67.52s54 30.29 54 67.52-24.21 67.52-54 67.52-54-30.29-54-67.52zm4.37 0c0 34.83 22.26 63.16 49.62 63.16s49.63-28.33 49.63-63.16-22.26-63.16-49.63-63.16-49.62 28.33-49.62 63.16z"
                    style={{
                        WebkitTransformOrigin: 262.17,
                        MsTransformOrigin: 262.17,
                        transformOrigin: 262.17,
                    }}
                    id="ela1rthqutf6b"
                    fill="#C7C7C7"
                    className="animable"
                ></path>
                <path
                    d="M255.49 375.57c0 6.1 3.92 11 8.75 11s8.76-4.94 8.76-11-3.92-11-8.76-11-8.75 4.9-8.75 11z"
                    style={{
                        WebkitTransformOrigin: 264.245,
                        MsTransformOrigin: 264.245,
                        transformOrigin: 264.245,
                    }}
                    id="elb3823a4fye9"
                    fill="#C7C7C7"
                    className="animable"
                ></path>
                <ellipse
                    cx="261.44"
                    cy="375.57"
                    fill="#DBDBDB"
                    rx="8.75"
                    ry="11.04"
                    style={{
                        WebkitTransformOrigin: 261.44,
                        MsTransformOrigin: 261.44,
                        transformOrigin: 261.44,
                    }}
                    id="elisacd4ardd"
                    className="animable"
                ></ellipse>
                <path
                    style={{
                        WebkitTransformOrigin: 221.81,
                        MsTransformOrigin: 221.81,
                        transformOrigin: 221.81,
                    }}
                    id="elhwvg9ekqzzm"
                    fill="#C7C7C7"
                    d="M182.18 373.39H261.44V377.75H182.18z"
                    className="animable"
                ></path>
                <path
                    d="M341.86 439.47c0 7.93 5.1 14.36 11.39 14.36s11.38-6.43 11.38-14.36-5.1-14.36-11.38-14.36-11.39 6.43-11.39 14.36z"
                    style={{
                        WebkitTransformOrigin: 353.245,
                        MsTransformOrigin: 353.245,
                        transformOrigin: 353.245,
                    }}
                    id="elvoln3m78mkq"
                    fill="#C7C7C7"
                    className="animable"
                ></path>
                <ellipse
                    cx="349.6"
                    cy="439.47"
                    fill="#DBDBDB"
                    rx="11.39"
                    ry="14.36"
                    style={{
                        WebkitTransformOrigin: 349.6,
                        MsTransformOrigin: 349.6,
                        transformOrigin: 349.6,
                    }}
                    id="elaqsh1q48j28"
                    className="animable"
                ></ellipse>
                <path
                    style={{
                        WebkitTransformOrigin: 306.23,
                        MsTransformOrigin: 306.23,
                        transformOrigin: 306.23,
                    }}
                    id="el5i8ln996iyw"
                    fill="#A6A6A6"
                    d="M261.14 274.41H351.32V309.23H261.14z"
                    className="animable"
                    transform="rotate(180)"
                ></path>
                <path
                    d="M275.76 393h75.56v-4.37h-75.56a12.41 12.41 0 01-12.4-12.39V197a16.78 16.78 0 00-16.76-16.76h-10.18v4.36h10.18A12.41 12.41 0 01259 197v179.22A16.78 16.78 0 00275.76 393z"
                    style={{
                        WebkitTransformOrigin: 293.87,
                        MsTransformOrigin: 293.87,
                        transformOrigin: 293.87,
                    }}
                    id="el13fy6lmq04sb"
                    fill="#C7C7C7"
                    className="animable"
                ></path>
                <path
                    d="M349.14 425.11h4.36v-171.9a15.11 15.11 0 00-15.09-15.09h-77.23v4.36h77.23a10.74 10.74 0 0110.73 10.73z"
                    style={{
                        WebkitTransformOrigin: 307.34,
                        MsTransformOrigin: 307.34,
                        transformOrigin: 307.34,
                    }}
                    id="eli1txotxz2io"
                    fill="#C7C7C7"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 236.425,
                        MsTransformOrigin: 236.425,
                        transformOrigin: 236.425,
                    }}
                    id="eltkkd00c27ia"
                    fill="#263238"
                    d="M222.91 177.97H249.94V186.64H222.91z"
                    className="animable"
                    transform="rotate(180)"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 220.705,
                        MsTransformOrigin: 220.705,
                        transformOrigin: 220.705,
                    }}
                    id="eln5n324notg"
                    fill="#263238"
                    d="M182.18 196.91H259.23V302.45H182.18z"
                    className="animable"
                    transform="rotate(180)"
                ></path>
                <path
                    d="M252.28 166.32c-4.54 24.33-2.9 58 2.21 63.61 6.42 7 21.81-20.87 20.92-22-.67-.87-5.8-24.18-11.16-40.18-5.58-16.68-10.85-7.45-11.97-1.43z"
                    style={{
                        WebkitTransformOrigin: 262.536,
                        MsTransformOrigin: 262.536,
                        transformOrigin: 262.536,
                    }}
                    id="elcs1ajy2t2ak"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M253.47 228.35c2.8 6.26 12.37 7.83 42.42 10.51 4.16.37 14.67-28.27 10.25-28.89-5.56-.79-29.71-3.49-31.32-3.43-13.58.56-23.46 17.09-21.35 21.81z"
                    style={{
                        WebkitTransformOrigin: 280.195,
                        MsTransformOrigin: 280.195,
                        transformOrigin: 280.195,
                    }}
                    id="el9bq20m3uz1"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M274.82 206.54c-6.08 1-11.29 4.26-15.83 8.31 3.53-5.06 9.53-8.69 15.83-8.31z"
                    style={{
                        WebkitTransformOrigin: 266.905,
                        MsTransformOrigin: 266.905,
                        transformOrigin: 266.905,
                    }}
                    id="eldbmz5jgkzvp"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M291.27 238.26a92.14 92.14 0 0011.8 5.49c3.23 1.06 12.63 3.85 14.15.4 1-2.35-4.3-4.64-8-6.35-2-.9-4.36-3.07-3.73-4.33 1.11-2.21 6.17.22 9.48 2.29 6.41 4 14.88 11.15 19 8 1.55-1.21-.12-3.55-2.61-5.87 4.07 2.75 8.43 5 10.21 3.77 1-.72 1.09-1.76.58-3a2.92 2.92 0 003.23-.39c1.4-1.37.81-3.48-.6-5.67a1.63 1.63 0 001.26-.77c3-4.27-10.9-17.28-15.81-18.62a125.57 125.57 0 00-29.84-3.82c-5.93 4.39-9.13 28.86-9.12 28.87z"
                    style={{
                        WebkitTransformOrigin: 318.865,
                        MsTransformOrigin: 318.865,
                        transformOrigin: 318.865,
                    }}
                    id="elz5gnibjm0hl"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M313.16 225.56a24.81 24.81 0 019.59 4.07c3.62 2.57 6 5.5 9 8.48.08.08 0 .21-.12.13-1.43-1.42-7.38-6.76-8.93-8a23.54 23.54 0 00-9.54-4.64s-.04-.04 0-.04z"
                    style={{
                        WebkitTransformOrigin: 322.462,
                        MsTransformOrigin: 322.462,
                        transformOrigin: 322.462,
                    }}
                    id="eldaeuto8vzb"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M316.08 219.47a59.1 59.1 0 0111.18 4.3c3.83 2.11 6.76 5.45 9.65 8.66 1.74 1.93 3.43 3.89 5.08 5.9.07.08-.05.21-.12.13q-4.39-5-9.09-9.68a31 31 0 00-10.09-6.85c-2.17-.91-4.4-1.65-6.62-2.39-.07-.02-.07-.08.01-.07z"
                    style={{
                        WebkitTransformOrigin: 329.015,
                        MsTransformOrigin: 329.015,
                        transformOrigin: 329.015,
                    }}
                    id="el578ekv8bo3j"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M320.36 214.2c3.69.89 6.92 1.65 10.15 3.76 4.27 2.78 8.33 7.38 9.76 9 1.57 1.8 3.08 3.65 4.57 5.52.06.08-.07.18-.13.11a123.16 123.16 0 00-11-11.63 24.6 24.6 0 00-6.21-4.34 44.07 44.07 0 00-7.17-2.4s.01-.03.03-.02z"
                    style={{
                        WebkitTransformOrigin: 332.593,
                        MsTransformOrigin: 332.593,
                        transformOrigin: 332.593,
                    }}
                    id="elbky75i72z3h"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M244.73 200.84l26.67-14s-3.63-14.69-6.79-22.54c-4.17-10.39-9-11.28-13.54 1.68-3.07 8.66-6.34 34.86-6.34 34.86z"
                    style={{
                        WebkitTransformOrigin: 258.065,
                        MsTransformOrigin: 258.065,
                        transformOrigin: 258.065,
                    }}
                    id="elnizsehcb3j"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <g
                    style={{
                        WebkitTransformOrigin: 258.065,
                        MsTransformOrigin: 258.065,
                        transformOrigin: 258.065,
                    }}
                    id="el0pbd5hrw5e"
                    className="animable"
                    opacity="0.5"
                >
                    <path
                        d="M244.73 200.84l26.67-14s-3.63-14.69-6.79-22.54c-4.17-10.39-9-11.28-13.54 1.68-3.07 8.66-6.34 34.86-6.34 34.86z"
                        style={{
                            WebkitTransformOrigin: 258.065,
                            MsTransformOrigin: 258.065,
                            transformOrigin: 258.065,
                        }}
                        id="elp8nfqe8jied"
                        fill="#FFF"
                        className="animable"
                    ></path>
                </g>
                <path
                    d="M246.11 196.89c3.74-2.31 7.5-4.56 11.37-6.64q2.89-1.56 5.84-3c2-1 4-1.76 6-2.76.11-.06.19.12.08.17-2 .9-3.87 2.08-5.81 3.09s-3.89 2-5.82 3.07c-3.86 2.06-7.73 4.12-11.54 6.27-.15.03-.23-.09-.12-.2z"
                    style={{
                        WebkitTransformOrigin: 257.756,
                        MsTransformOrigin: 257.756,
                        transformOrigin: 257.756,
                    }}
                    id="elxt4bfqzpud"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M254.75 174a10.21 10.21 0 00-2.82-.68 10.19 10.19 0 002.55 1.38 10.31 10.31 0 002.82.69 10.23 10.23 0 00-2.55-1.39zm13.25 8.57a10.5 10.5 0 00-1.51-2.47 10.5 10.5 0 00.82 2.78 10.63 10.63 0 001.51 2.48 10.35 10.35 0 00-.82-2.79zm-16.16 6.67a10.11 10.11 0 00-2.48 1.51 10.47 10.47 0 002.79-.83 10.06 10.06 0 002.47-1.51 10.05 10.05 0 00-2.79.83z"
                    style={{
                        WebkitTransformOrigin: 259.09,
                        MsTransformOrigin: 259.09,
                        transformOrigin: 259.09,
                    }}
                    id="elykyfxwbwr18"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M267.65 188.8l-22.92 12s3.31-26.2 6.34-34.87c2.32-6.65 4.73-9.64 7.08-9.6z"
                    style={{
                        WebkitTransformOrigin: 256.19,
                        MsTransformOrigin: 256.19,
                        transformOrigin: 256.19,
                    }}
                    id="elpuxc3fr2tlr"
                    className="animable"
                    opacity="0.1"
                ></path>
                <path
                    d="M257.46 220.59l6.76 19.88s64.86 10.69 79.28 26.82c21 23.48 65.25 103.56 65.25 103.56l-38.35 27.44s-54.95-89.74-60.46-97.24S223.9 286.16 209 274.6s-4.56-54-4.56-54z"
                    style={{
                        WebkitTransformOrigin: 304.848,
                        MsTransformOrigin: 304.848,
                        transformOrigin: 304.848,
                    }}
                    id="el1jy7byamael"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M454.68 390.14c-1.87 1.85-67.88 33.77-71.09 33.39-.37 0-9-13.31-9-13.31-2.54-5.15-26.79-43.31-26.79-43.31l45.91-26.63 21.6 42.23s10.71-.63 20.26-.73c5.89-.07 11 0 12.37.26 3.49.79 8.62 6.27 6.74 8.1z"
                    style={{
                        WebkitTransformOrigin: 401.441,
                        MsTransformOrigin: 401.441,
                        transformOrigin: 401.441,
                    }}
                    id="eln055i8oe3c"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    d="M363.44 392.15l-4.84-8s19.68-3.91 35.92-12.6c0 0-7.52 18.74-14 20.56s-17.08.04-17.08.04z"
                    style={{
                        WebkitTransformOrigin: 376.56,
                        MsTransformOrigin: 376.56,
                        transformOrigin: 376.56,
                    }}
                    id="elcdc513uikrp"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    d="M363.44 392.15l-5-7.85-.15-.24c3.18-.74 6.36-1.56 9.5-2.48a145.31 145.31 0 0027.71-11l-.51 1.23c-2.89 6.52-5.84 13.17-10.82 18.4-2.52 2.84-6.59 3-10.12 3a59.78 59.78 0 01-10.6-1zm0 0a64.72 64.72 0 0010.59.57c3.4-.18 7.23-.27 9.6-3.07 4.7-5.2 7.69-11.84 10.44-18.24l.68.61a118.21 118.21 0 01-17.63 7.45 147.13 147.13 0 01-18.48 4.93l.14-.31 4.66 8.06z"
                    style={{
                        WebkitTransformOrigin: 376.895,
                        MsTransformOrigin: 376.895,
                        transformOrigin: 376.895,
                    }}
                    id="elijatv45vmc"
                    fill="#DBDBDB"
                    className="animable"
                ></path>
                <path
                    d="M403.64 358.17l7.53 13.76s-15.06 20-23.13 23.88-18.04 7.74-18.04 7.74l-7.43-11.4s13.88-4.51 20.87-9.68 20.2-24.3 20.2-24.3z"
                    style={{
                        WebkitTransformOrigin: 386.87,
                        MsTransformOrigin: 386.87,
                        transformOrigin: 386.87,
                    }}
                    id="eliwvi0yzxx2f"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    d="M403.64 358.17l7.72 13.66.08.12-.09.12c-2.65 3.56-5.43 7-8.3 10.38-4.42 5-8.75 10.27-14.59 13.64-6 2.93-12.12 5.46-18.3 7.93l-.38.15-.22-.34-7.4-11.42-.33-.51a123.42 123.42 0 0013.26-5.18c4.1-1.94 8.17-4.05 11.31-7.35 6.36-6.51 11.83-13.88 17.24-21.2zm0 0c-5.16 7.54-10.46 15-16.78 21.67-3.15 3.38-7.27 5.69-11.41 7.65a121.15 121.15 0 01-12.76 5.1l.25-.69 7.46 11.38-.6-.19c6.15-2.42 12.31-4.93 18.26-7.8 5.67-3.27 10.06-8.5 14.48-13.28q4.38-5 8.45-10.21v.24l-7.33-13.87z"
                    style={{
                        WebkitTransformOrigin: 386.635,
                        MsTransformOrigin: 386.635,
                        transformOrigin: 386.635,
                    }}
                    id="el9cf1mcq547p"
                    fill="#DBDBDB"
                    className="animable"
                ></path>
                <path
                    d="M415.58 381.91s10.64-.4 15.7-.4c0 0-6.19 9.57-8.23 13.33s-2 12.64-2 12.64l-20.81 9.73s2.47-14.24 5.11-18.92 10.23-16.38 10.23-16.38z"
                    style={{
                        WebkitTransformOrigin: 415.76,
                        MsTransformOrigin: 415.76,
                        transformOrigin: 415.76,
                    }}
                    id="eldx4na69amg"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    d="M415.58 381.91c4.16-.18 12-.54 16.2-.7-2.61 4.18-5.24 8.37-7.68 12.63a13.08 13.08 0 00-1.43 3.15 42.48 42.48 0 00-1.19 10.49v.3l-.26.12c-5.18 2.45-15.62 7.33-20.82 9.72l-.8.37a126.29 126.29 0 013.54-15.13c1.34-4.73 4.43-8.74 7-12.85 1.79-2.72 3.59-5.42 5.43-8.1zm0 0l-5.12 8.3c-2.42 4.2-5.4 8.11-6.64 12.87s-2.32 9.44-3.18 14.21l-.63-.49c5.17-2.46 15.6-7.34 20.8-9.75l-.27.43c.2-4.74.26-9.91 2.83-14.06s5.07-8.08 7.68-12.06l.23.42c-3.92.05-11.79.1-15.7.13z"
                    style={{
                        WebkitTransformOrigin: 415.69,
                        MsTransformOrigin: 415.69,
                        transformOrigin: 415.69,
                    }}
                    id="elaj0kc8g1x27"
                    fill="#DBDBDB"
                    className="animable"
                ></path>
                <path
                    d="M327.54 328.76c-8.72-14-15.8-25.26-17.6-27.71-5.51-7.51-86.05-14.9-100.95-26.45s-4.56-54-4.56-54h53l6.76 19.88s37.37 6.16 61.69 16.19z"
                    style={{
                        WebkitTransformOrigin: 264.238,
                        MsTransformOrigin: 264.238,
                        transformOrigin: 264.238,
                    }}
                    id="elru7ftg9nsb"
                    className="animable"
                    opacity="0.1"
                ></path>
                <path
                    d="M360.57 434.39c-2.5.83-75.81.36-78.52-1.39-.33-.18-.42-6.82-.41-15.89v-.18c0-5.75-1-54.89-1-54.89l46.52-.25 1.48 48.39s9.89 4.16 18.5 8.29c5.32 2.53 9.93 4.84 11 5.68 2.74 2.24 4.93 9.43 2.43 10.24z"
                    style={{
                        WebkitTransformOrigin: 321.153,
                        MsTransformOrigin: 321.153,
                        transformOrigin: 321.153,
                    }}
                    id="elvy1i22w71pp"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M327.69 395.16l-46.41.11s-3.6-97.76-9.36-100.41c-9.69-4.45-47.55-3.67-69.31-19.4-17.67-12.77-3.07-54.87-3.07-54.87h46.78s6.41 14.84 7.48 19.34c0 0 45.25 12.44 60.87 29.57 14.84 16.29 13.02 125.66 13.02 125.66z"
                    style={{
                        WebkitTransformOrigin: 260.817,
                        MsTransformOrigin: 260.817,
                        transformOrigin: 260.817,
                    }}
                    id="elt0c17s4geut"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M313.73 425.82s6.86-10 12.21-12.26a17 17 0 0110.54-.86c1.07.1 20.43 9 23 11.45s4.13 9.34 2.17 10.64-78.89 0-79.8-.42-1.56-8-1.08-8.55 32.96 0 32.96 0z"
                    style={{
                        WebkitTransformOrigin: 321.57,
                        MsTransformOrigin: 321.57,
                        transformOrigin: 321.57,
                    }}
                    id="elzw5dgqy5s9g"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M193.43 237.09c-1.68 6.75-7 34.39 16.49 46.55s56.05 9.06 59.75 11.51 4.59 21.72 4.59 21.72 28.69-25.6 40.3-27.64 43.72-3.82 43.72-3.82-7.37-17.73-23.59-27.37c-19.91-11.83-70.47-17.57-70.47-17.57z"
                    style={{
                        WebkitTransformOrigin: 274.997,
                        MsTransformOrigin: 274.997,
                        transformOrigin: 274.997,
                    }}
                    id="elrf29hsgznok"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <path
                    d="M193.43 237.09c-1.68 6.75-7 34.39 16.49 46.55s56.05 9.06 59.75 11.51 4.59 21.72 4.59 21.72 28.69-25.6 40.3-27.64 43.72-3.82 43.72-3.82-7.37-17.73-23.59-27.37c-19.91-11.83-70.47-17.57-70.47-17.57z"
                    style={{
                        WebkitTransformOrigin: 274.997,
                        MsTransformOrigin: 274.997,
                        transformOrigin: 274.997,
                    }}
                    id="elafnizht1gwk"
                    fill="#FFF"
                    className="animable"
                    opacity="0.5"
                ></path>
                <path
                    d="M230.09 238.84a2 2 0 000 .24c.06-.08.12-.15.17-.23zm34.32 3.83a9.86 9.86 0 00-2.82-.68 10.19 10.19 0 002.55 1.38 9.86 9.86 0 002.82.68 10.53 10.53 0 00-2.55-1.38zm-55.07-4.82l-2.1-.1.75.32a10.21 10.21 0 002.82.68 8.28 8.28 0 00-1.47-.9zm-14 10.57a10.47 10.47 0 00-1.52-2.48 10.4 10.4 0 00.83 2.78 9.93 9.93 0 001.51 2.48 10.28 10.28 0 00-.77-2.78zm47.35-2.8a10.43 10.43 0 00-2.48 1.51 11.07 11.07 0 005.26-2.34 10 10 0 00-2.73.83zm20.48 19.25a9.54 9.54 0 00-.68 2.82 11.21 11.21 0 002.06-5.37 10.19 10.19 0 00-1.33 2.55zm-67.36 2.49a15.16 15.16 0 00-.47 1.49c.09.2.19.4.29.59a11.35 11.35 0 00.89-1.82 9.85 9.85 0 00.67-2.82 10.41 10.41 0 00-1.33 2.56zm35.47-7.86a9.88 9.88 0 00-.69 2.82 10.95 10.95 0 002.11-5.32 10.33 10.33 0 00-1.37 2.5zm23.53 19.22A10.13 10.13 0 00252 278a10.47 10.47 0 002.56 1.39 10.21 10.21 0 002.82.68 9.94 9.94 0 00-2.52-1.35zm-2-24A10.21 10.21 0 00250 254a11.09 11.09 0 005.37 2.07 10.23 10.23 0 00-2.55-1.37zm-45.39 4.59a10.4 10.4 0 00-2.82-.69 9.68 9.68 0 002.56 1.39 10.12 10.12 0 002.82.68 10.59 10.59 0 00-2.55-1.4zm12.46-9.44a10.24 10.24 0 00-1.51-2.48 10 10 0 00.83 2.78 10.43 10.43 0 001.51 2.48 10 10 0 00-.82-2.8zm42.3 39.09a10.22 10.22 0 00-.69 2.82 10 10 0 001.39-2.56 10.12 10.12 0 00.68-2.82 10.25 10.25 0 00-1.37 2.54zm-21.72-.62a10.22 10.22 0 00-.69 2.82 11.09 11.09 0 002.07-5.37 10.19 10.19 0 00-1.37 2.53zm-32.26-6.11a9.87 9.87 0 00-1.51-2.47 9.62 9.62 0 00.7 2.47c.35.21.7.43 1.07.63-.07-.23-.16-.44-.25-.65zm21.65-3.3a10.41 10.41 0 00-1.52-2.47 10.4 10.4 0 00.83 2.78 9.87 9.87 0 001.51 2.47 10.5 10.5 0 00-.81-2.8zm13.43-10.39a9.91 9.91 0 00-2.47 1.52 10.05 10.05 0 002.78-.83 9.86 9.86 0 002.48-1.52 10.47 10.47 0 00-2.78.81zM274 254.72a10.39 10.39 0 00-2.48 1.5 11.19 11.19 0 005.26-2.33 9.33 9.33 0 00-2.78.83zM216.85 269a10.24 10.24 0 00-2.48 1.51 9.94 9.94 0 002.78-.82 10.15 10.15 0 002.48-1.52 10.4 10.4 0 00-2.78.83zM317 250.82a8.69 8.69 0 00-.26 1.54 8.11 8.11 0 00.85-1.36zm-29.69 13.36a10.21 10.21 0 00-.68 2.82 9.88 9.88 0 001.38-2.55 10.21 10.21 0 00.68-2.82 10.53 10.53 0 00-1.35 2.55zm24.25 24.15a11.43 11.43 0 00-.57 2c.19-.08.38-.16.56-.22a12.34 12.34 0 00.71-1.52 10.21 10.21 0 00.68-2.82 10.08 10.08 0 00-1.35 2.56zm22-4a10.59 10.59 0 00-.69 2.82 10.23 10.23 0 001.39-2.55 10.12 10.12 0 00.68-2.82 10.53 10.53 0 00-1.36 2.53zm-46 2.71a10.22 10.22 0 00-2.82-.69 9.92 9.92 0 002.55 1.39 10.21 10.21 0 002.82.68 10.19 10.19 0 00-2.49-1.42zm-1.2-40.38a10.22 10.22 0 00-2.82-.69A11.09 11.09 0 00289 248a9.88 9.88 0 00-2.58-1.36zM310.49 264a10.4 10.4 0 00-2.82-.69 10.29 10.29 0 002.56 1.39 10.12 10.12 0 002.82.68 10.59 10.59 0 00-2.56-1.38zm21.51-2.84a10.52 10.52 0 00-1.5-2.48 10.14 10.14 0 00.82 2.78 10.63 10.63 0 001.51 2.48 9.85 9.85 0 00-.83-2.78zm-32.64 16.72a10.11 10.11 0 00-1.51-2.48 10.12 10.12 0 00.83 2.79 9.87 9.87 0 001.51 2.47 10.05 10.05 0 00-.83-2.78zm-24.61 20.19a9.86 9.86 0 00-1.52-2.48 10.66 10.66 0 00.83 2.78 10.27 10.27 0 001.52 2.48 10.05 10.05 0 00-.83-2.78zm72.55-25.13a10.39 10.39 0 00-2.48 1.5 11.19 11.19 0 005.26-2.33 10.05 10.05 0 00-2.78.83zM300.25 252a10.11 10.11 0 00-2.48 1.51 10.47 10.47 0 002.79-.83 10.06 10.06 0 002.47-1.51 10.05 10.05 0 00-2.78.83zm21.26 23.54a10.43 10.43 0 00-2.48 1.51 10.1 10.1 0 002.79-.82 10.54 10.54 0 002.48-1.52 10.36 10.36 0 00-2.79.85zm-45.46 39.76l.51-.44a2.7 2.7 0 00.05-.41 6.56 6.56 0 00-.56.85zm7.93-7.05l.25.19.16-.13a2.7 2.7 0 00-.39-.06zM297.75 297a6.3 6.3 0 00.2 1l.35-.25c-.17-.25-.3-.49-.55-.75zm58.44-14.88a10.18 10.18 0 00-1.51-2.47 10.15 10.15 0 00.83 2.78 10.3 10.3 0 001.51 2.48 10.36 10.36 0 00-.83-2.77zm-81.34-6.58a10.43 10.43 0 00-2.48 1.51 10.1 10.1 0 002.79-.82 10.29 10.29 0 002.47-1.52 10.4 10.4 0 00-2.78.85z"
                    style={{
                        WebkitTransformOrigin: 275.42,
                        MsTransformOrigin: 275.42,
                        transformOrigin: 275.42,
                    }}
                    id="el5fnmq6n8h2c"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M251.93 245.82c10.36 1.78 25.47 4 36 5.65l9 1.47c9.18 1.23 17.31 7.37 21.9 15.24-4.43-6.53-11-11.74-18.72-13.72-2.24-.53-9.93-1.61-12.33-2-12-2-24-3.82-35.86-6.64z"
                    style={{
                        WebkitTransformOrigin: 285.375,
                        MsTransformOrigin: 285.375,
                        transformOrigin: 285.375,
                    }}
                    id="el9k85m7yzhhf"
                    className="animable"
                    opacity="0.1"
                ></path>
                <path
                    d="M269 247.09c7.52.59 14.9 1.39 22.43 1.79a58 58 0 01-22.43-1.79z"
                    style={{
                        WebkitTransformOrigin: 280.215,
                        MsTransformOrigin: 280.215,
                        transformOrigin: 280.215,
                    }}
                    id="el0bn5zuqw6c9l"
                    className="animable"
                    opacity="0.1"
                ></path>
                <path
                    d="M264.22 240.47l-70.79-3.38c-.27-.68 18.46-63.2 47.69-82.14 5.15-3.33 14.91-.29 17.27 3.29 9.34 14.12 5.83 82.23 5.83 82.23z"
                    style={{
                        WebkitTransformOrigin: 229.147,
                        MsTransformOrigin: 229.147,
                        transformOrigin: 229.147,
                    }}
                    id="eli6chf529dh"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <g
                    style={{
                        WebkitTransformOrigin: 229.147,
                        MsTransformOrigin: 229.147,
                        transformOrigin: 229.147,
                    }}
                    id="elmk9e1rs7kq"
                    className="animable"
                    opacity="0.5"
                >
                    <path
                        d="M264.22 240.47l-70.79-3.38c-.27-.68 18.46-63.2 47.69-82.14 5.15-3.33 14.91-.29 17.27 3.29 9.34 14.12 5.83 82.23 5.83 82.23z"
                        style={{
                            WebkitTransformOrigin: 229.147,
                            MsTransformOrigin: 229.147,
                            transformOrigin: 229.147,
                        }}
                        id="elnz2ii7sn4p"
                        fill="#FFF"
                        className="animable"
                    ></path>
                </g>
                <path
                    d="M245.83 160.91a10.21 10.21 0 00-.68 2.82 10.23 10.23 0 001.39-2.55 10.57 10.57 0 00.68-2.82 10.23 10.23 0 00-1.39 2.55zm-9.23 36.57a10.21 10.21 0 00-.68 2.82 10.95 10.95 0 002.06-5.37 10.53 10.53 0 00-1.38 2.55zm-30.11 14.64a10.19 10.19 0 00-.68 2.83 10.47 10.47 0 001.39-2.56 10.11 10.11 0 00.67-2.82 10.72 10.72 0 00-1.38 2.55zm24.25 24.15a10.65 10.65 0 00-.65 2.57h.14a10.69 10.69 0 001.21-2.32 10.21 10.21 0 00.68-2.82 10.41 10.41 0 00-1.38 2.57zm22-4a10.59 10.59 0 00-.69 2.82 9.57 9.57 0 001.39-2.54 9.86 9.86 0 00.68-2.82 10.47 10.47 0 00-1.39 2.52zm-33.5-48.94a10.21 10.21 0 00-.68 2.82 11.36 11.36 0 002.07-5.37 9.92 9.92 0 00-1.4 2.53zm35.51-9.33a10.21 10.21 0 00-2.82-.68 10.19 10.19 0 002.55 1.38 10.31 10.31 0 002.82.69 10.23 10.23 0 00-2.55-1.39zm10 29.28l-.72-.31a10.22 10.22 0 00-2.81-.68 9.67 9.67 0 002.54 1.38c.33.12.67.24 1 .34.04-.22.03-.46.02-.7zm-56.53 34.06a10.13 10.13 0 00-2.82-.69 8.79 8.79 0 001.81 1.07l2.1.1c-.31-.15-.69-.3-1.06-.45zm21.4-25.45a9.86 9.86 0 00-2.83-.69 10.29 10.29 0 002.56 1.39 10.11 10.11 0 002.82.67 10.16 10.16 0 00-2.52-1.34zm6.64-33.58a10.11 10.11 0 00-1.51-2.48 11 11 0 002.34 5.26 10.05 10.05 0 00-.8-2.75zm14.87 30.76a10.56 10.56 0 00-1.51-2.48 10.28 10.28 0 00.82 2.78 10.43 10.43 0 001.51 2.48 10.28 10.28 0 00-.79-2.75zm-32.64 16.72a10.22 10.22 0 00-1.52-2.47 10.51 10.51 0 00.83 2.78 9.87 9.87 0 001.51 2.47 10.39 10.39 0 00-.79-2.75zm45.51-3.41a5.4 5.4 0 00.82-.15v-.45a5.8 5.8 0 00-.82.6zM219.4 200a10.11 10.11 0 00-2.48 1.51 10.47 10.47 0 002.79-.83 10.06 10.06 0 002.47-1.51 10.05 10.05 0 00-2.78.83zm21.26 23.54a10.47 10.47 0 00-2.48 1.52 11.19 11.19 0 005.27-2.35 10.36 10.36 0 00-2.79.79zm-43.53 1.82l-.33.94a10.2 10.2 0 002.35-1.46 8.86 8.86 0 00-2.02.48zm54.7-36.08a10.11 10.11 0 00-2.48 1.51 10.47 10.47 0 002.79-.83 10.06 10.06 0 002.47-1.51 10.05 10.05 0 00-2.78.79z"
                    style={{
                        WebkitTransformOrigin: 230.81,
                        MsTransformOrigin: 230.81,
                        transformOrigin: 230.81,
                    }}
                    id="elhwtt9o6osz4"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M232.46 162.13c-17.92 21-39.27 63.92-34.14 72 5.71 8.94 33.57-17.3 33.35-18.9-.16-1.2 4.66-26 10.54-44.72s-5.32-13.51-9.75-8.38z"
                    style={{
                        WebkitTransformOrigin: 220.712,
                        MsTransformOrigin: 220.712,
                        transformOrigin: 220.712,
                    }}
                    id="el5rg0j1upr1"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M198 233.5c4.1 6.41 15.92 8.07 45.27 15.05 4.06 1 18.24-27.86 14-29.12-5.4-1.58-26.34-4.54-27.94-4.71-13.52-1.4-34.08 14.44-31.33 18.78z"
                    style={{
                        WebkitTransformOrigin: 227.901,
                        MsTransformOrigin: 227.901,
                        transformOrigin: 227.901,
                    }}
                    id="el2uwl7g0orgr"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M248.33 217.86s12.29 1.06 20.4 2.44c4.53.77 12.17 2.79 15.24 4.88 4.59 3.12 21.77 19.12 18 23.37-3.43 3.85-16.46-11.77-16.46-11.77s14.54 14.6 9.55 18.48-17.34-15.74-17.34-15.74 14.59 15.34 8.82 18.52c-4.36 2.41-16.56-14.72-16.56-14.72s12.46 13.27 8.08 15.94C273.21 262.2 261 247.1 261 247.1c-12.27 4.91-20.12 2.22-25.47-.35-1.34-.62 12.8-28.89 12.8-28.89z"
                    style={{
                        WebkitTransformOrigin: 268.973,
                        MsTransformOrigin: 268.973,
                        transformOrigin: 268.973,
                    }}
                    id="elez2bz2syl4s"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M280.8 231.41c1.77 1.65 3.57 3.31 5.19 5.12s3.17 3.67 4.61 5.61a42.34 42.34 0 014.89 8.11c-2.71-4.94-8.4-11.49-10-13.29s-3.14-3.69-4.75-5.49c-.05-.05.02-.1.06-.06z"
                    style={{
                        WebkitTransformOrigin: 288.106,
                        MsTransformOrigin: 288.106,
                        transformOrigin: 288.106,
                    }}
                    id="el9kn2v78wfih"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M274.18 237.13c2.17 2.21 4.4 4.32 6.47 6.62s3.81 4.66 5.71 7.08c.15.19 0 .21-.16 0-2-2.35-4-4.38-6-6.7s-3.95-4.74-6.05-7c-.06.01 0-.04.03 0z"
                    style={{
                        WebkitTransformOrigin: 280.273,
                        MsTransformOrigin: 280.273,
                        transformOrigin: 280.273,
                    }}
                    id="elwitfugxrmik"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M267.61 241a68.85 68.85 0 019.12 10.89c.14.19-.06.19-.21 0-3-3.68-5.26-6.59-9-10.78-.08-.04.02-.17.09-.11z"
                    style={{
                        WebkitTransformOrigin: 272.134,
                        MsTransformOrigin: 272.134,
                        transformOrigin: 272.134,
                    }}
                    id="el3wxqgls5qf5"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M264.82 219.7a112.23 112.23 0 0111.05 2c2.72.7 5.63 1.31 8 2.92 6.68 5 13 11.14 17.21 18.4a38.58 38.58 0 00-3.47-4.38 106.4 106.4 0 00-12.1-11.54 16.54 16.54 0 00-4.57-2.93c-5.2-2-10.73-3.12-16.13-4.47z"
                    style={{
                        WebkitTransformOrigin: 282.945,
                        MsTransformOrigin: 282.945,
                        transformOrigin: 282.945,
                    }}
                    id="el7sjhh1ojbui"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M231.67 215.18a44.4 44.4 0 00-17.93 3.23 22.05 22.05 0 0117.93-3.23z"
                    style={{
                        WebkitTransformOrigin: 222.705,
                        MsTransformOrigin: 222.705,
                        transformOrigin: 222.705,
                    }}
                    id="elcuxw5os9df7"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M209.24 187.08l30.09 1.33s4.27-14.52 5.49-22.9c1.63-11.07-2.11-14.27-12.54-5.36-6.99 5.96-23.04 26.93-23.04 26.93z"
                    style={{
                        WebkitTransformOrigin: 227.213,
                        MsTransformOrigin: 227.213,
                        transformOrigin: 227.213,
                    }}
                    id="el6ijis3pi8lg"
                    fill="#578AD6"
                    className="animable"
                ></path>
                <g
                    style={{
                        WebkitTransformOrigin: 227.213,
                        MsTransformOrigin: 227.213,
                        transformOrigin: 227.213,
                    }}
                    id="elmxtu2b1n4nf"
                    className="animable"
                    opacity="0.5"
                >
                    <path
                        d="M209.24 187.08l30.09 1.33s4.27-14.52 5.49-22.9c1.63-11.07-2.11-14.27-12.54-5.36-6.99 5.96-23.04 26.93-23.04 26.93z"
                        style={{
                            WebkitTransformOrigin: 227.213,
                            MsTransformOrigin: 227.213,
                            transformOrigin: 227.213,
                        }}
                        id="elqqdovjfose"
                        fill="#FFF"
                        className="animable"
                    ></path>
                </g>
                <path
                    d="M237.26 188.32c.7-.12 1.39-.19 2.08-.24l-.33.23c1.51-6 3.09-11.93 5.14-17.76a84.38 84.38 0 01-1.84 9.08c-.78 3.09-1.68 6.15-2.76 9.15a22.63 22.63 0 01-2.29-.46z"
                    style={{
                        WebkitTransformOrigin: 240.705,
                        MsTransformOrigin: 240.705,
                        transformOrigin: 240.705,
                    }}
                    id="elzbb58cn862m"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M242.76 176c.69-1.21 1.35-2.38 2.09-3.54a4.6 4.6 0 01-2.09 3.54z"
                    style={{
                        WebkitTransformOrigin: 243.805,
                        MsTransformOrigin: 243.805,
                        transformOrigin: 243.805,
                    }}
                    id="elf9rpuifuprv"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M228 164.36c-.37.39-.74.79-1.11 1.21a11.41 11.41 0 003.79-2 9.48 9.48 0 00-2.68.79zm8.28 14a10.11 10.11 0 00-1.51-2.48 11 11 0 002.34 5.26 10.05 10.05 0 00-.82-2.8zm-17.06 5a10.21 10.21 0 00-.68 2.82 11.36 11.36 0 002.07-5.37 9.92 9.92 0 00-1.38 2.5z"
                    style={{
                        WebkitTransformOrigin: 227.825,
                        MsTransformOrigin: 227.825,
                        transformOrigin: 227.825,
                    }}
                    id="eltk7g6cob8"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M212.42 184.36c4.39-.11 8.78-.16 13.17 0q3.28.12 6.56.33c2.19.14 4.37.5 6.55.61.12 0 .1.2 0 .19-2.17-.22-4.4-.15-6.58-.26s-4.38-.2-6.57-.28c-4.37-.16-8.75-.33-13.13-.39-.14-.02-.12-.2 0-.2z"
                    style={{
                        WebkitTransformOrigin: 225.553,
                        MsTransformOrigin: 225.553,
                        transformOrigin: 225.553,
                    }}
                    id="elgf28w61d2vk"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M255.41 167.62c-4 .4-9.8-6.38-11.77-11.5-.13-.35 3-13.24 3.33-15.86.07-.54 15.9 6.19 15.9 6.19a42.43 42.43 0 00-2.94 9.85c-.04.38-.68 10.94-4.52 11.32z"
                    style={{
                        WebkitTransformOrigin: 253.253,
                        MsTransformOrigin: 253.253,
                        transformOrigin: 253.253,
                    }}
                    id="ellhx0c55lixe"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M259.89 156.83c0 .2 0 .45-.07.73a9.36 9.36 0 01-1.62-.13c-8.91-1.4-10.45-12.78-10.71-17.12l.3.09.67.23.37.13.5.18.26.1.56.21 1.89.73a1 1 0 00.18.07c.17.07.33.13.49.21 1.33.52 2.76 1.11 4.11 1.67l.42.17 2 .84.5.21.28.12.28.12.73.31.4.16.27.12a1.27 1.27 0 01.26.11l.84.35a41.9 41.9 0 00-2.94 9.85v.53z"
                    style={{
                        WebkitTransformOrigin: 255.145,
                        MsTransformOrigin: 255.145,
                        transformOrigin: 255.145,
                    }}
                    id="el86yf00nk1ml"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M267.3 118.09a8.69 8.69 0 017 6.93c1.12 6.06-.89 11.58-1.42 11.9s-5.58-18.83-5.58-18.83z"
                    style={{
                        WebkitTransformOrigin: 270.967,
                        MsTransformOrigin: 270.967,
                        transformOrigin: 270.967,
                    }}
                    id="el67pu23dtouy"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M245.88 123.16c-2 5.82.56 22.89 4.61 26.82 5.88 5.68 15.78 6.53 20.68-.6 4.75-6.91 1-29.1-3.52-32.69-6.71-5.29-18.84-2.12-21.77 6.47z"
                    style={{
                        WebkitTransformOrigin: 259.279,
                        MsTransformOrigin: 259.279,
                        transformOrigin: 259.279,
                    }}
                    id="el8be58y2e5vg"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M262.39 134s-.08.07-.07.12c.2 1.14.24 2.49-.74 3v.06c1.26-.35 1.19-2.13.81-3.18z"
                    style={{
                        WebkitTransformOrigin: 262.106,
                        MsTransformOrigin: 262.106,
                        transformOrigin: 262.106,
                    }}
                    id="el9v7low0gflb"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M261.19 132.94c-1.87.13-1.48 3.86.26 3.74s1.31-3.85-.26-3.74z"
                    style={{
                        WebkitTransformOrigin: 261.265,
                        MsTransformOrigin: 261.265,
                        transformOrigin: 261.265,
                    }}
                    id="eldtagmuld4rk"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M268.8 133.5c0-.05.1 0 .1.09.08 1.16.37 2.48 1.46 2.75v.07c-1.3-.05-1.67-1.8-1.56-2.91z"
                    style={{
                        WebkitTransformOrigin: 269.571,
                        MsTransformOrigin: 269.571,
                        transformOrigin: 269.571,
                    }}
                    id="elipq0ijbfq8j"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M269.71 132.18c1.84-.33 2.38 3.38.67 3.69s-2.22-3.41-.67-3.69z"
                    style={{
                        WebkitTransformOrigin: 270.099,
                        MsTransformOrigin: 270.099,
                        transformOrigin: 270.099,
                    }}
                    id="elh7wi5p0oi9g"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M259.54 131.39c.5-.19.92-.43 1.39-.66a2.51 2.51 0 001.3-.95.81.81 0 00-.23-.94 2 2 0 00-2 0 2.89 2.89 0 00-1.52 1.42.85.85 0 001.06 1.13z"
                    style={{
                        WebkitTransformOrigin: 260.355,
                        MsTransformOrigin: 260.355,
                        transformOrigin: 260.355,
                    }}
                    id="elevxmq4l1que"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M271 130.15a13.29 13.29 0 01-1.52-.23 2.45 2.45 0 01-1.51-.53.81.81 0 01-.06-1 2 2 0 011.91-.57 2.94 2.94 0 011.88.92.84.84 0 01-.7 1.41z"
                    style={{
                        WebkitTransformOrigin: 269.846,
                        MsTransformOrigin: 269.846,
                        transformOrigin: 269.846,
                    }}
                    id="eltvhzurisjwr"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M262.14 144.85c.3.25.62.59 1 .58a3.07 3.07 0 001.21-.42l.06.06a1.59 1.59 0 01-1.4.78 1.25 1.25 0 01-1-.93c-.01-.07.08-.1.13-.07z"
                    style={{
                        WebkitTransformOrigin: 263.21,
                        MsTransformOrigin: 263.21,
                        transformOrigin: 263.21,
                    }}
                    id="el10fj42f3lcd"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M263 141.27a4 4 0 002.81 1.47 4.92 4.92 0 001.43-.08 1.1 1.1 0 00.26-.06l.25-.07a.29.29 0 00.21-.28.45.45 0 000-.11V142c-.07-.9-.3-2.24-.3-2.24.34.13 2.08.7 2 .24a60 60 0 00-2.78-11.76c0-.12-.23-.07-.2.05.46 3.7 1.57 7.3 2.09 11a7.05 7.05 0 00-1.92-.37c-.12.05.49 2.59.49 3a5.49 5.49 0 01-4.21-.84c-.13.01-.22.1-.13.19z"
                    style={{
                        WebkitTransformOrigin: 266.313,
                        MsTransformOrigin: 266.313,
                        transformOrigin: 266.313,
                    }}
                    id="eleg3j73nhbyb"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M247.77 140.72c2.11.16 3.07-6.26 3.2-8.68.12-2.14-.64-8.65-.64-9.1s9.84 3.73 14.49 1.18 7-7.74 6.58-9.84-7.72-6-13.12-5.1-11.12 9.29-11.12 9.29a25.08 25.08 0 001.67-3.69c-.13-.22-3.28 1.92-3.37 4.51 0 0 0-3.23-.27-3.23s-2.37 3.23-1.32 5.1c0 0-2.51 3.37-2.14 6.38s3.57 12.98 6.04 13.18z"
                    style={{
                        WebkitTransformOrigin: 256.57,
                        MsTransformOrigin: 256.57,
                        transformOrigin: 256.57,
                    }}
                    id="elm7bfwimd61"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M268.12 122.3a17.1 17.1 0 01-4.32 2.7 11.46 11.46 0 01-5.55.33 17.52 17.52 0 01-5.31-1.74c-1.47-.75-2.84-1.74-4.37-2.36-.38-.15-.66.41-.39.67a18.27 18.27 0 0010.48 4.64 10.49 10.49 0 009.48-4.22s0-.03-.02-.02z"
                    style={{
                        WebkitTransformOrigin: 258.106,
                        MsTransformOrigin: 258.106,
                        transformOrigin: 258.106,
                    }}
                    id="elhfxi6pxfpkk"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M250.26 137.11s-3.77-5.53-6.28-4.2.27 9.34 3.19 10.46a3 3 0 004-1.55z"
                    style={{
                        WebkitTransformOrigin: 247.086,
                        MsTransformOrigin: 247.086,
                        transformOrigin: 247.086,
                    }}
                    id="el790s233l5f"
                    fill="#F7A9A0"
                    className="animable"
                ></path>
                <path
                    d="M244.83 135.18s-.05.07 0 .08c2 .86 3.09 2.78 3.82 4.76a1.63 1.63 0 00-2.45-.48c-.05 0 0 .12.06.11a1.82 1.82 0 012 .66 9.22 9.22 0 01.95 1.64c.09.19.42.09.35-.12v-.05c.06-2.61-1.92-6.3-4.73-6.6z"
                    style={{
                        WebkitTransformOrigin: 247.189,
                        MsTransformOrigin: 247.189,
                        transformOrigin: 247.189,
                    }}
                    id="eln9rno2qcapm"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 326.68,
                        MsTransformOrigin: 326.68,
                        transformOrigin: 326.68,
                    }}
                    id="elw2ybx5b6ztn"
                    fill="#263238"
                    d="M278.46 434.37H374.9V444.57H278.46z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 224.975,
                        MsTransformOrigin: 224.975,
                        transformOrigin: 224.975,
                    }}
                    id="eln2ddkpokit"
                    fill="#A6A6A6"
                    d="M179.82 274.46H270.13V309.28H179.82z"
                    className="animable"
                    transform="rotate(180)"
                ></path>
                <path
                    d="M194.57 393h75.56v-4.36h-75.56a12.41 12.41 0 01-12.4-12.4V197.09a16.77 16.77 0 00-16.75-16.76h-10.19v4.37h10.19a12.41 12.41 0 0112.39 12.39v179.18A16.78 16.78 0 00194.57 393z"
                    style={{
                        WebkitTransformOrigin: 212.68,
                        MsTransformOrigin: 212.68,
                        transformOrigin: 212.68,
                    }}
                    id="elc6u3gorrwp"
                    fill="#C7C7C7"
                    className="animable"
                ></path>
                <path
                    d="M268 438.14h4.36V253.26a15.11 15.11 0 00-15.09-15.09H180v4.37h77.23A10.74 10.74 0 01268 253.26z"
                    style={{
                        WebkitTransformOrigin: 226.18,
                        MsTransformOrigin: 226.18,
                        transformOrigin: 226.18,
                    }}
                    id="elm6kzmmupiwe"
                    fill="#C7C7C7"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 155.235,
                        MsTransformOrigin: 155.235,
                        transformOrigin: 155.235,
                    }}
                    id="elaris9wjgspk"
                    fill="#263238"
                    d="M141.72 178.02H168.75V186.69H141.72z"
                    className="animable"
                    transform="rotate(180)"
                ></path>
                <path
                    d="M125.79 375.57c0-42 27.38-76.17 61-76.17s61 34.17 61 76.17-27.38 76.17-61 76.17-61-34.17-61-76.17zm6.11 0c0 38.63 24.63 70.06 54.92 70.06s54.92-31.43 54.92-70.06-24.64-70.06-54.92-70.06-54.92 31.43-54.92 70.06z"
                    style={{
                        WebkitTransformOrigin: 186.79,
                        MsTransformOrigin: 186.79,
                        transformOrigin: 186.79,
                    }}
                    id="el9hxgsb79ffs"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M128 375.57c0-37.23 24.22-67.52 54-67.52s54 30.29 54 67.52-24.22 67.52-54 67.52-54-30.29-54-67.52zm4.36 0c0 34.83 22.27 63.16 49.63 63.16s49.63-28.33 49.63-63.16-22.25-63.16-49.62-63.16-49.63 28.33-49.63 63.16z"
                    style={{
                        WebkitTransformOrigin: 182,
                        MsTransformOrigin: 182,
                        transformOrigin: 182,
                    }}
                    id="elw6h416nx5yc"
                    fill="#C7C7C7"
                    className="animable"
                ></path>
                <path
                    d="M175.31 375.57c0 6.1 3.92 11 8.76 11s8.75-4.94 8.75-11-3.92-11-8.75-11-8.76 4.9-8.76 11z"
                    style={{
                        WebkitTransformOrigin: 184.065,
                        MsTransformOrigin: 184.065,
                        transformOrigin: 184.065,
                    }}
                    id="elixmkfl1c72s"
                    fill="#C7C7C7"
                    className="animable"
                ></path>
                <ellipse
                    cx="181.26"
                    cy="375.57"
                    fill="#DBDBDB"
                    rx="8.75"
                    ry="11.04"
                    style={{
                        WebkitTransformOrigin: 181.26,
                        MsTransformOrigin: 181.26,
                        transformOrigin: 181.26,
                    }}
                    id="elcauq8q4z16u"
                    className="animable"
                ></ellipse>
                <ellipse
                    cx="271.08"
                    cy="439.47"
                    fill="#C7C7C7"
                    rx="11.39"
                    ry="14.36"
                    style={{
                        WebkitTransformOrigin: 271.08,
                        MsTransformOrigin: 271.08,
                        transformOrigin: 271.08,
                    }}
                    id="el91zf3x19326"
                    className="animable"
                ></ellipse>
                <ellipse
                    cx="267.43"
                    cy="439.47"
                    fill="#DBDBDB"
                    rx="11.39"
                    ry="14.36"
                    style={{
                        WebkitTransformOrigin: 267.43,
                        MsTransformOrigin: 267.43,
                        transformOrigin: 267.43,
                    }}
                    id="eldf232xt9fgs"
                    className="animable"
                ></ellipse>
            </g>
            <g
                id="freepik--speech-bubble--inject-2"
                style={{
                    WebkitTransformOrigin: 188.16,
                    MsTransformOrigin: 188.16,
                    transformOrigin: 188.16,
                }}
                className="animable animator-active"
            >
                <path
                    d="M210.42 76.61a20.23 20.23 0 01-33.8 12.8l-10.12 1.48 5.07-8.74a20.23 20.23 0 1138.85-5.54z"
                    style={{
                        WebkitTransformOrigin: 188.515,
                        MsTransformOrigin: 188.515,
                        transformOrigin: 188.515,
                    }}
                    id="ela89dcebni8k"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M210.42 76.61a20.33 20.33 0 01-4.08 10.26 18.76 18.76 0 01-4 3.92 20.57 20.57 0 01-10.33 4 18.81 18.81 0 01-2.81 0 17.61 17.61 0 01-2.8-.29 20.37 20.37 0 01-10-4.94l.24.08-10.11 1.55-.74.11.37-.65 5-8.76v.34a20.43 20.43 0 1139.22-5.68zm0 0A20.32 20.32 0 00204.28 60a20.53 20.53 0 00-7.8-4.6 20.19 20.19 0 00-9-.68 20 20 0 00-8.35 3.3 20.93 20.93 0 00-6.06 6.61 20 20 0 00-2.56 8.55 20.3 20.3 0 001.42 8.82l.07.18-.09.16-5.09 8.73-.37-.53 10.13-1.42h.14l.1.09a19.88 19.88 0 009.69 5 18 18 0 002.74.34 19.7 19.7 0 002.77 0 20 20 0 005.4-1.19 19 19 0 004.88-2.63 24 24 0 002.14-1.78 22.62 22.62 0 001.83-2.09 20.27 20.27 0 004.15-10.25z"
                    style={{
                        WebkitTransformOrigin: 188.153,
                        MsTransformOrigin: 188.153,
                        transformOrigin: 188.153,
                    }}
                    id="elvdhg3y1o0d"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M201.58 75.12a2.45 2.45 0 11-2.45-2.44 2.45 2.45 0 012.45 2.44z"
                    style={{
                        WebkitTransformOrigin: 199.13,
                        MsTransformOrigin: 199.13,
                        transformOrigin: 199.13,
                    }}
                    id="elulja9t035sg"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M192.8 75.12a2.45 2.45 0 11-2.45-2.44 2.45 2.45 0 012.45 2.44z"
                    style={{
                        WebkitTransformOrigin: 190.35,
                        MsTransformOrigin: 190.35,
                        transformOrigin: 190.35,
                    }}
                    id="eljll81yr9xwj"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M184 75.12a2.45 2.45 0 11-2.45-2.44 2.45 2.45 0 012.45 2.44z"
                    style={{
                        WebkitTransformOrigin: 181.55,
                        MsTransformOrigin: 181.55,
                        transformOrigin: 181.55,
                    }}
                    id="el4blvrc1hhbw"
                    fill="#263238"
                    className="animable"
                ></path>
            </g>
            <defs>
                <filter id="active" height="200%">
                    <feMorphology
                        in="SourceAlpha"
                        operator="dilate"
                        radius="2"
                        result="DILATED"
                    ></feMorphology>
                    <feFlood
                        floodColor="#32DFEC"
                        floodOpacity="1"
                        result="PINK"
                    ></feFlood>
                    <feComposite
                        in="PINK"
                        in2="DILATED"
                        operator="in"
                        result="OUTLINE"
                    ></feComposite>
                    <feMerge>
                        <feMergeNode in="OUTLINE"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                </filter>
                <filter id="hover" height="200%">
                    <feMorphology
                        in="SourceAlpha"
                        operator="dilate"
                        radius="2"
                        result="DILATED"
                    ></feMorphology>
                    <feFlood floodColor="red" floodOpacity="0.5" result="PINK"></feFlood>
                    <feComposite
                        in="PINK"
                        in2="DILATED"
                        operator="in"
                        result="OUTLINE"
                    ></feComposite>
                    <feMerge>
                        <feMergeNode in="OUTLINE"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                    <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
                </filter>
            </defs>
        </svg>
    );
}
